<template>
  <div class="wrapperPage w-full" v-if="dadosProposta">
    <div
      v-if="dadosProposta.dataAceite"
      class="row p-2 w-full header-aprove hideInPrintVersion"
    >
      <div class="flex justify-center items-center">
        <vs-icon
          icon-pack="material-icons"
          icon="check_circle"
          color="white"
          size="small"
        />
        <p class="text-white ml-1">{{ `${$t('PROPOSTA')} ${$t('ACEITA')}` }}</p>
      </div>
    </div>
    <div
      class="pagebreak-inside-avoid"
      v-if="
        dadosProposta.dadosAssociacao.capaProposta &&
        !empresasNaoImprimeCapa.includes(dadosProposta.idEmpresa)
      "
    >
      <img
        class="capaImpressao showInPrintVersion pagebreak-inside-avoid"
        :src="dadosProposta.dadosAssociacao.capaProposta"
      />
    </div>
    <div class="container flex">
      <div
        class="logoPlusWpp text-left justify-center w-full flex pt-8 pb-8 sm:justify-between"
      >
        <div class="logo">
          <img
            style="max-height: 200px; max-width: 200px"
            :src="dadosProposta.dadosAssociacao.logo"
            :alt="
              dadosProposta.idEmpresa === empresa.ERP_GERAL
                ? 'Bem Protege'
                : dadosProposta.dadosAssociacao.nome
            "
          />
        </div>
        <div class="boxWpp hidden sm:block">
          <a
            class="hideInPrintVersion"
            target="_blank"
            :href="returnLinkWhatsVendedor(dadosProposta.dadosVendedor.usuario)"
          >
            <div class="whatsAppDiv flex pr-6 pl-3 justify-between fade-in">
              <div>
                <img src="../../assets/images/pages/wpp-icon.png" width="50" />
              </div>
              <div class="wppConsultor pt-1 pb-1 flex">
                <p class="wppTexto text-white">
                  {{ `${$t('WhatsApp')} ${$t('do')} ${$t('Consultor')}` }}
                </p>
                <p class="wppNumero text-white">
                  {{ dadosProposta.dadosVendedor.telefone }}
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div
      class="blueBar p-12 pb-10 sm:p-16"
      :class="
        !dadosProposta.dadosAssociacao.videoProposta ? 'bar-without-video' : ''
      "
    >
      <div class="wrapper video">
        <video
          autoplay
          muted
          loop
          id="myVideo"
          v-if="dadosProposta.dadosAssociacao.videoProposta"
        >
          <source
            :src="dadosProposta.dadosAssociacao.videoProposta"
            type="video/mp4"
          />
        </video>
      </div>
      <div class="container wrapper" style="position: none !important">
        <p class="textBlueBar1">
          {{
            `${$t('Olá')} ${dadosProposta.dadosCliente.associado}. ${$t(
              'Esta',
            )} ${$t('é')} ${$t('uma')} ${$t('proposta')}
          ${$t('para')} ${$t('o')} ${$t('seu')} ${$t('veículo')}:`
          }}
        </p>
        <p class="textBlueBar2">
          {{ dadosProposta.dadosVeiculo.veiculoMarca }} -
          {{ dadosProposta.dadosVeiculo.veiculoModelo }}
          {{
            dadosProposta.dadosVeiculo.anoFabricacao == '32000'
              ? '0km'
              : `${dadosProposta.dadosVeiculo.anoFabricacao} / ${dadosProposta.dadosVeiculo.anoModelo}`
          }}
        </p>
        <p
          class="textBlueBar1"
          v-if="
            dadosProposta.exibirValoresVeiculoNaProposta ||
            dadosProposta.exibirValoresVeiculoNaProposta === null
          "
        >
          {{ `${$t('Valor FIPE')}:` }}
          {{ dadosProposta.dadosVeiculo.valorFipe | currency }}
        </p>
        <p
          class="textBlueBar1"
          v-if="dadosProposta.nomeGrupo || dadosProposta.nomeGrupo != null"
        >
          {{ dadosProposta.nomeGrupo }}
        </p>
      </div>
    </div>
    <div class="container contInfo pb-5">
      <div class="vx-row flex justify-between">
        <div class="blocoInfo blocoInfoPai vx-col sm:w-3/5 w-full p-5">
          <h2 class="pb-3 titleListItems">
            #{{ dadosProposta.idProposta }} -
            {{
              dadosProposta.idEmpresa === empresa.ERP_GERAL
                ? 'Bem Protege'
                : dadosProposta.dadosAssociacao.nome
            }}
          </h2>
          <h3 class="pb-5">
            {{ `${$t('Este plano inclui as seguintes coberturas')}` }}
          </h3>

          <div v-if="dadosProposta.permiteInvoiceSelfService">
            <div
              class="produtosBeneficios"
              v-for="(produto, index) in this.produtosObrigatorios"
              :key="`prod-obrig-${index}`"
            >
              <div
                class="flex items-center justify-between"
                v-if="produto.produtoVisivel"
              >
                <div class="flex nome items-center">
                  <vs-icon
                    icon-pack="material-icons"
                    icon="check"
                    color="green"
                    size="medium"
                  />
                  <span
                    class="listItemsProtecoes ml-3"
                    :style="
                      produto.excluido ? 'text-decoration: line-through;' : ''
                    "
                    >{{ produto.nomeProduto }}</span
                  >
                </div>
                <div class="descricao flex" v-if="produto.visivelProposta">
                  <span
                    v-if="produto.descontoConcedido > 0"
                    :style="'text-decoration: line-through;'"
                    class="valorprod mr-2"
                    >{{ produto.valor | currency }}</span
                  >
                  <span class="listItemsProtecoes">{{
                    produto.valorFinal | currency
                  }}</span>
                </div>
              </div>
              <vs-divider class="mb-1 mt-1" v-if="produto.produtoVisivel" />
            </div>
          </div>

          <div v-if="!dadosProposta.permiteInvoiceSelfService">
            <div
              class="produtosBeneficios"
              v-for="(produto, index) in this.produtosObrigatorios"
              :key="`prod-obrig2-${index}`"
            >
              <div
                class="flex items-center justify-between"
                v-if="
                  produto.produtoVisivel == true && produto.excluido != true
                "
              >
                <div class="flex nome items-center">
                  <vs-icon
                    icon-pack="material-icons"
                    icon="check"
                    color="green"
                    size="medium"
                  />
                  <span class="listItemsProtecoes ml-3">{{
                    produto.nomeProduto
                  }}</span>
                </div>
                <div class="descricao flex" v-if="produto.visivelProposta">
                  <span class="listItemsProtecoes">{{
                    produto.valorFinal | currency
                  }}</span>
                </div>
              </div>
              <vs-divider
                class="mb-1 mt-1"
                v-if="produto.produtoVisivel && produto.excluido != true"
              />
            </div>
          </div>

          <div
            class="produtosBeneficios"
            v-for="(beneficio, index) in dadosProposta.beneficios"
            :key="`prod-benef-${index}`"
          >
            <div class="flex items-center justify-between">
              <div class="nome flex items-center">
                <vs-icon
                  icon-pack="material-icons"
                  icon="check"
                  color="green"
                  size="medium"
                />
                <span class="listItemsProtecoes ml-3">{{
                  beneficio.nome
                }}</span>
              </div>
              <div class="descricao flex" v-if="beneficio.descricao">
                <span class="listItemsProtecoes"
                  >{{ beneficio.descricao }}
                </span>
              </div>
            </div>
            <vs-divider class="mb-1 mt-1" />
          </div>

          <div v-if="dadosProposta.permiteInvoiceSelfService != true">
            <div
              class="produtosBeneficios"
              v-for="(produto, index) in produtosOpcionais"
              :key="`prod-opc-${index}`"
            >
              <div
                class="flex items-center justify-between"
                v-if="produto.produtoVisivel && produto.selecionado"
              >
                <div class="flex nome items-center">
                  <vs-icon
                    icon-pack="material-icons"
                    icon="check"
                    color="green"
                    size="medium"
                  />
                  <span class="listItemsProtecoes ml-3">{{
                    produto.nomeProduto
                  }}</span>
                </div>
                <div
                  class="descricao flex"
                  v-if="produto.visivelProposta && produto.selecionado"
                >
                  <span
                    v-if="produto.descontoConcedido > 0"
                    :style="'text-decoration: line-through;'"
                    class="valorprod mr-2"
                    >{{ produto.valor | currency }}</span
                  >

                  <span class="listItemsProtecoes">{{
                    produto.valorFinal | currency
                  }}</span>
                </div>
              </div>
              <vs-divider
                class="mb-1 mt-1"
                v-if="produto.produtoVisivel && produto.selecionado"
              />
            </div>
          </div>

          <div
            v-if="
              dadosProposta.permiteInvoiceSelfService == true &&
              produtosOpcionais.length > 0
            "
            class="pagebreak-inside-avoid"
            :class="
              existeProdutoOpcionalVeiculoSelecionado == true
                ? null
                : 'hideInPrintVersion'
            "
          >
            <h2 class="pb-3 titleListItems mt-8">
              {{ `${$t('Coberturas')} ${$t('opcionais')}` }}
            </h2>
            <h3
              class="pb-5 hideInPrintVersion"
              v-if="dadosProposta.permiteInvoiceSelfService == true"
            >
              {{
                `${$t('Acrescente')} ${$t('serviços')} ${$t('opcionais')} ${$t(
                  'ao',
                )} ${$t('seu')} ${$t('plano')}`
              }}
            </h3>
            <h3
              class="pb-5 showInPrintVersion"
              v-if="dadosProposta.permiteInvoiceSelfService == true"
            >
              {{
                `${$t('Os')} ${$t('serviços')} ${$t('opcionais')} ${$t(
                  'inclusos',
                )} ${$t('no')} ${$t('seu')} ${$t('plano')}`
              }}
            </h3>
            <div
              class="opcionais"
              v-for="(produtos, index) in produtosOpcionais"
              :key="`prod-opcin-${index}`"
              :class="produtos.selecionado ? null : 'hideInPrintVersion'"
            >
              <div v-if="produtos.exibir">
                <div
                  v-if="dadosProposta.permiteInvoiceSelfService"
                  class="flex items-center justify-between"
                >
                  <div class="flex w-4/5 items-center">
                    <div>
                      <vs-icon
                        class="showInPrintVersion"
                        icon-pack="material-icons"
                        icon="check"
                        color="green"
                        size="medium"
                      />
                      <vs-switch
                        class="hideInPrintVersion"
                        color="success"
                        vs-icon-on="check_box"
                        vs-icon-off="block"
                        v-model="produtos.selecionado"
                        @input="
                          selecionaProduto(produtos, produtos.selecionado),
                            verificaExisteEscolhidoOpcional('veiculo')
                        "
                        :key="`prod-opci-${index}-${produtos.idProduto}`"
                        :disabled="
                          !(
                            (propostaVencida == false ||
                              aprovarPropostasVencidas) &&
                            dadosProposta.idStatus == 1 &&
                            isInterno == false
                          )
                        "
                      >
                        <span slot="on"></span>
                        <span slot="off"></span>
                      </vs-switch>
                    </div>
                    <span class="listItemsOpcionais ml-3">{{
                      produtos.nomeProduto
                    }}</span>
                  </div>
                  <span>{{ produtos.valorFinal | currency }}</span>
                </div>
                <vs-divider class="my-1" />
              </div>
            </div>
          </div>

          <!-- agregados -->
          <div
            v-if="agregados && agregados.length > 0"
            class="mt-8 pagebreak-inside-avoid"
          >
            <div v-if="agregados[0].unificarAgregados">
              <div>
                <div class="container contInfo pb-5 mt-2 w-full">
                  <div class="vx-row flex justify-between">
                    <div class="blocoInfo w-full p-5">
                      <h3
                        v-for="(agregado, id) in agregados"
                        :key="`agreg-${agregado.idPropostaComplemento}-${id}`"
                        class="pb-2 titleListItems"
                      >
                        # {{ agregado.descricao }}
                      </h3>
                      <vs-divider class="my-3" />
                      <h3 class="pb-5">
                        {{
                          `${$t('Este plano inclui as seguintes coberturas')}`
                        }}
                      </h3>
                      <div>
                        <div
                          class="produtosBeneficios"
                          v-for="(produtosObrigatorios, index) in agregados[0]
                            .produtosObrigatorios"
                          :key="`prod-agreg-${index}`"
                        >
                          <div
                            class="flex items-center justify-between"
                            v-if="produtosObrigatorios.produtoVisivel"
                          >
                            <div class="flex nome items-center">
                              <vs-icon
                                icon-pack="material-icons"
                                icon="check"
                                color="green"
                                size="medium"
                              />
                              <span
                                class="listItemsProtecoes ml-3"
                                :style="
                                  produtosObrigatorios.excluido
                                    ? 'text-decoration: line-through;'
                                    : ''
                                "
                                >{{ produtosObrigatorios.nomeProduto }}</span
                              >
                            </div>
                            <div
                              class="descricao flex"
                              v-if="produtosObrigatorios.visivelProposta"
                            >
                              <span
                                v-if="
                                  produtosObrigatorios.descontoConcedido > 0
                                "
                                :style="'text-decoration: line-through;'"
                                class="valorprod mr-2"
                                >{{
                                  produtosObrigatorios.valor | currency
                                }}</span
                              >
                              <span class="listItemsProtecoes">{{
                                produtosObrigatorios.valorFinal | currency
                              }}</span>
                            </div>
                          </div>
                          <vs-divider
                            class="mb-1 mt-1"
                            v-if="produtosObrigatorios.produtoVisivel"
                          />
                        </div>
                      </div>
                      <div
                        v-if="dadosProposta.permiteInvoiceSelfService"
                        class="pagebreak-inside-avoid"
                        :class="
                          existeProdutoOpcionalAgregadoSelecionado
                            ? null
                            : 'hideInPrintVersion'
                        "
                      >
                        <h2 class="pb-3 titleListItems mt-8">
                          {{ `${$t('Coberturas')} ${$t('opcionais')}` }}
                        </h2>

                        <h3 class="pb-5 hideInPrintVersion">
                          {{
                            `${$t('Acrescente')} ${$t('serviços')} ${$t(
                              'opcionais',
                            )} ${$t('ao')} ${$t('seu')} ${$t('plano')}`
                          }}
                        </h3>
                        <h3 class="pb-5 showInPrintVersion">
                          {{
                            `${$t('Os')} ${$t('serviços')} ${$t(
                              'opcionais',
                            )} ${$t('inclusos')} ${$t('no')} ${$t('seu')} ${$t(
                              'plano',
                            )}`
                          }}
                        </h3>
                        <div
                          class="opcionais"
                          v-for="(produtosOpcionais, index) in agregados[0]
                            .produtosOpcionais"
                          :key="`prodAgreg-${index}`"
                          :class="
                            produtosOpcionais.selecionado
                              ? null
                              : 'hideInPrintVersion'
                          "
                        >
                          <div class="flex items-center justify-between">
                            <div class="flex w-4/5 items-center">
                              <div>
                                <vs-icon
                                  class="showInPrintVersion"
                                  icon-pack="material-icons"
                                  icon="check"
                                  color="green"
                                  size="medium"
                                />
                                <vs-switch
                                  class="hideInPrintVersion"
                                  color="success"
                                  vs-icon-on="check_box"
                                  vs-icon-off="block"
                                  v-model="produtosOpcionais.selecionado"
                                  @input="
                                    selecionaProdutoAgregado(
                                      produtosOpcionais,
                                      produtosOpcionais.selecionado,
                                      index,
                                    ),
                                      verificaExisteEscolhidoOpcional(
                                        'agregado',
                                      )
                                  "
                                  :key="`prodAgreg-item-${index}`"
                                  :disabled="
                                    !(
                                      (propostaVencida == false ||
                                        aprovarPropostasVencidas) &&
                                      dadosProposta.idStatus == 1 &&
                                      isInterno == false
                                    )
                                  "
                                >
                                  <span slot="on"></span>
                                  <span slot="off"></span>
                                </vs-switch>
                              </div>
                              <span class="listItemsOpcionais ml-3">{{
                                produtosOpcionais.nomeProduto
                              }}</span>
                            </div>
                            <span>{{
                              produtosOpcionais.valorFinal | currency
                            }}</span>
                          </div>
                          <vs-divider class="my-1" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div
                v-for="(agregado, id) in agregados"
                :key="`agreg-${agregado.idPropostaComplemento}-${id}`"
              >
                <div class="container contInfo pb-5 mt-2 w-full">
                  <div class="vx-row flex justify-between">
                    <div class="blocoInfo w-full p-5">
                      <h2 class="pb-3 titleListItems">
                        # {{ agregado.descricao }}
                      </h2>
                      <h3 class="pb-5">
                        {{
                          `${$t('Este plano inclui as seguintes coberturas')}`
                        }}
                      </h3>
                      <div>
                        <div
                          class="produtosBeneficios"
                          v-for="(
                            produtosObrigatorios, index
                          ) in agregado.produtosObrigatorios"
                          :key="`prod-agreg-${index}`"
                        >
                          <div
                            class="flex items-center justify-between"
                            v-if="produtosObrigatorios.produtoVisivel"
                          >
                            <div class="flex nome items-center">
                              <vs-icon
                                icon-pack="material-icons"
                                icon="check"
                                color="green"
                                size="medium"
                              />
                              <span
                                class="listItemsProtecoes ml-3"
                                :style="
                                  produtosObrigatorios.excluido
                                    ? 'text-decoration: line-through;'
                                    : ''
                                "
                                >{{ produtosObrigatorios.nomeProduto }}</span
                              >
                            </div>
                            <div
                              class="descricao flex"
                              v-if="produtosObrigatorios.visivelProposta"
                            >
                              <span
                                v-if="
                                  produtosObrigatorios.descontoConcedido > 0
                                "
                                :style="'text-decoration: line-through;'"
                                class="valorprod mr-2"
                                >{{
                                  produtosObrigatorios.valor | currency
                                }}</span
                              >
                              <span class="listItemsProtecoes">{{
                                produtosObrigatorios.valorFinal | currency
                              }}</span>
                            </div>
                          </div>
                          <vs-divider
                            class="mb-1 mt-1"
                            v-if="produtosObrigatorios.produtoVisivel"
                          />
                        </div>
                      </div>
                      <div
                        v-if="dadosProposta.permiteInvoiceSelfService"
                        class="pagebreak-inside-avoid"
                        :class="
                          existeProdutoOpcionalAgregadoSelecionado
                            ? null
                            : 'hideInPrintVersion'
                        "
                      >
                        <h2 class="pb-3 titleListItems mt-8">
                          {{ `${$t('Coberturas')} ${$t('opcionais')}` }}
                        </h2>

                        <h3 class="pb-5 hideInPrintVersion">
                          {{
                            `${$t('Acrescente')} ${$t('serviços')} ${$t(
                              'opcionais',
                            )} ${$t('ao')} ${$t('seu')} ${$t('plano')}`
                          }}
                        </h3>
                        <h3 class="pb-5 showInPrintVersion">
                          {{
                            `${$t('Os')} ${$t('serviços')} ${$t(
                              'opcionais',
                            )} ${$t('inclusos')} ${$t('no')} ${$t('seu')} ${$t(
                              'plano',
                            )}`
                          }}
                        </h3>
                        <div
                          class="opcionais"
                          v-for="(
                            produtosOpcionais, index
                          ) in agregado.produtosOpcionais"
                          :key="`prodAgreg-${index}`"
                          :class="
                            produtosOpcionais.selecionado
                              ? null
                              : 'hideInPrintVersion'
                          "
                        >
                          <div class="flex items-center justify-between">
                            <div class="flex w-4/5 items-center">
                              <div>
                                <vs-icon
                                  class="showInPrintVersion"
                                  icon-pack="material-icons"
                                  icon="check"
                                  color="green"
                                  size="medium"
                                />
                                <vs-switch
                                  class="hideInPrintVersion"
                                  color="success"
                                  vs-icon-on="check_box"
                                  vs-icon-off="block"
                                  v-model="produtosOpcionais.selecionado"
                                  @input="
                                    selecionaProdutoAgregado(
                                      produtosOpcionais,
                                      produtosOpcionais.selecionado,
                                      id,
                                    ),
                                      verificaExisteEscolhidoOpcional(
                                        'agregado',
                                      )
                                  "
                                  :key="`prodAgreg-item-${index}`"
                                  :disabled="
                                    !(
                                      (propostaVencida == false ||
                                        aprovarPropostasVencidas) &&
                                      dadosProposta.idStatus == 1 &&
                                      isInterno == false
                                    )
                                  "
                                >
                                  <span slot="on"></span>
                                  <span slot="off"></span>
                                </vs-switch>
                              </div>
                              <span class="listItemsOpcionais ml-3">{{
                                produtosOpcionais.nomeProduto
                              }}</span>
                            </div>
                            <span>{{
                              produtosOpcionais.valorFinal | currency
                            }}</span>
                          </div>
                          <vs-divider class="mb-1 mt-1" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- implementos -->
          <div v-if="dadosProposta.implemento">
            <div
              v-for="(implemento, index) in implementos"
              :key="`implem-${index}`"
              class="pagebreak-inside-avoid"
            >
              <div class="container contInfo pb-5 mt-2">
                <div class="vx-row flex justify-between">
                  <div class="blocoInfo w-full p-5">
                    <h2 class="pb-3 titleListItems">
                      # {{ implemento.descricao }}
                    </h2>
                    <div class="produtosBeneficios">
                      <div class="flex items-center justify-between">
                        <div class="flex nome items-center">
                          <vs-icon
                            icon-pack="material-icons"
                            icon="check"
                            color="green"
                            size="medium"
                            v-if="implemento.marca || implemento.modelo"
                          />
                          <span class="listItemsProtecoes ml-3"
                            >{{ implemento.marca }}
                            {{ implemento.modelo }}</span
                          >
                        </div>
                        <div class="descricao flex">
                          <span class="valorprod mr-2"
                            >{{ `${$t('Valor')} ${$t('protegido')}:` }}
                          </span>
                          <span class="listItemsProtecoes">{{
                            implemento.valorCobertura | currency
                          }}</span>
                        </div>
                      </div>
                      <vs-divider class="mb-1 mt-1" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-col sm:w-2/5 w-full blocoValorPai">
          <div class="blocoValor p-4 mt-3 sm:mt-0">
            <div class="flex blocoValorCont">
              <h5 class="text-center mt-6">
                {{ `${$t('O valor total mensal é')}:` }}
              </h5>
              <h4
                v-if="verificaDiferencaValoresMensalidade()"
                class="text-center valueCotacao mb-3 mt-3"
                style="color: #ccc; text-decoration: line-through"
              >
                {{ valorMensalidadeDiferenca | currency }}
              </h4>

              <!-- Valor da Mensalidade -->
              <h1 v-if="!isRecalculating" class="text-center valueCotacao">
                {{ valorMensalidade | currency }}
              </h1>
              <h1 v-else class="text-center valueCotacao">...</h1>

              <h5 class="pb-3 text-center">
                {{ `${$t('Valor Mensal')}` }}
              </h5>

              <vs-divider />

              <!-- Colocado a pedido do Riserio, solicitação da transdesk -->
              <div
                v-if="
                  !empresasNaoImprimePriParcela.includes(
                    dadosProposta.idEmpresa,
                  )
                "
              >
                <h5 class="text-center">
                  {{ `${$t('Primeira Parcela')}:` }}
                </h5>
                <h4
                  v-if="verificaDiferencaValoresEntrada()"
                  class="text-center valueCotacao mb-3 mt-3"
                  style="color: #ccc; text-decoration: line-through"
                >
                  {{ valorEntradaDiferenca | currency }}
                </h4>

                <!-- Primeira Parcela -->
                <h1 v-if="!isRecalculating" class="pb-3 titleListItems">
                  {{ valorEntrada | currency }}
                </h1>
                <h1 v-else class="pb-3 titleListItems">...</h1>
              </div>

              <!-- Lista de Produtos Avistas -->
              <ul class="text-center mb-3">
                <li v-for="(item, index) in produtosAvista()" :key="index">
                  <b>{{ item.placa ? `${item.placa} - ` : item.descricao }}</b>
                  {{ item.nomeProduto }} -
                  <span v-if="!isRecalculating">
                    {{ item.valorFinal | currency }}
                  </span>
                </li>
              </ul>

              <div
                v-if="dadosProposta.idStatus == 1 && !isInterno"
                class="mb-4 whatsAppDiv flex p-2 w-full fade-in justify-center hideInPrintVersion"
              >
                <div class="wppConsultor" @click="popupActive = true">
                  <h4 class="text-white queroContratar">
                    {{ `${$t('Quero')} ${$t('Contratar')}` }}
                  </h4>
                </div>
              </div>

              <!--h5 class="text-center mb-4">Ver detalhes</h5-->
              <div class="w-full">
                <h4 class="subtituloDetalhes justify-start">
                  {{ `${$t('Veículo')} ${$t('-')}` }}
                  {{
                    dadosProposta.dadosVeiculo.placa ||
                    dadosProposta.dadosVeiculo.chassi.toUpperCase()
                  }}
                </h4>
              </div>

              <vs-divider class="mb-0 mt-1" />

              <!-- Valor da Mensalidade -->
              <div class="w-full flex justify-between mt-1">
                <span>{{ `${$t('Valor Mensal')}` }}</span>
                <span v-if="!isRecalculating">
                  {{ valorMensalidadeSemAgregado | currency }}
                </span>
                <span v-else>...</span>
              </div>

              <vs-divider
                class="mb-0 mt-1"
                v-if="dadosProposta.exibirParticipacaoProposta"
              />
              <div
                class="w-full flex justify-between mt-1"
                v-if="dadosProposta.exibirParticipacaoProposta"
              >
                <span>Franquia</span>
                <span>{{ dadosProposta.valorCotaParticipacao }}% FIPE</span>
                <span v-if="dadosProposta.valorParticipacaoMinimo > 0"
                  >, mínimo de
                  {{ dadosProposta.valorParticipacaoMinimo | currency }}</span
                >
              </div>
              <vs-divider class="mb-5 mt-5" />

              <!-- valores agregados -->
              <div v-if="agregados && agregados.length > 0" class="w-full">
                <div v-if="agregados[0].unificarAgregados">
                  <div class="w-full">
                    <h5
                      v-for="(agregado, id) in agregados"
                      :key="`agr-${id}-${agregado.idPropostaComplemento}`"
                      class="subtituloDetalhes justify-start"
                    >
                      {{ agregado.descricao }}
                      {{ agregado.placa || agregado.chassi ? ' - ' : '' }}
                      {{ agregado.placa || agregado.chassi || '' }}
                    </h5>
                  </div>
                  <vs-divider class="mb-0 mt-1" />
                  <div class="w-full flex justify-between mt-1">
                    <span>{{ `${$t('Valor Mensal')}` }}</span>
                    <span>{{
                      (somaValorTotalMes(
                        agregados[0].produtosObrigatorios,
                        agregados[0].produtosOpcionais,
                      ) +
                        agregados[0].valorComissaoAplicadaFinal)
                        | currency
                    }}</span>
                  </div>
                  <vs-divider
                    class="mb-0 mt-1"
                    v-if="dadosProposta.exibirParticipacaoProposta"
                  />
                  <div
                    class="w-full flex justify-between mt-1"
                    v-if="dadosProposta.exibirParticipacaoProposta"
                  >
                    <span>{{ `${$t('Franquia')}` }}</span>
                    <span>{{
                      `${agregados[0].porcentagemParticipacao} ${$t('%')} ${$t(
                        'FIPE',
                      )}`
                    }}</span>
                    >
                    <span v-if="agregados[0].valorMinimoParticipacao > 0"
                      >, {{ `${$t('mínimo')} ${$t('de')}` }}
                      {{
                        agregados[0].valorMinimoParticipacao | currency
                      }}</span
                    >
                  </div>
                  <vs-divider class="mb-5 mt-5" />
                </div>
                <div v-else>
                  <div
                    v-for="(agregado, id) in agregados"
                    :key="`agr-${id}-${agregado.idPropostaComplemento}`"
                  >
                    <div class="w-full">
                      <h4 class="subtituloDetalhes justify-start">
                        {{ agregado.descricao }}
                        {{ agregado.placa || agregado.chassi ? ' - ' : '' }}
                        {{ agregado.placa || agregado.chassi || '' }}
                      </h4>
                    </div>
                    <vs-divider class="mb-0 mt-1" />
                    <div class="w-full flex justify-between mt-1">
                      <span>{{ `${$t('Valor')} ${$t('Mensal')}` }}</span>
                      <span>{{
                        (somaValorTotalMes(
                          agregado.produtosObrigatorios,
                          agregado.produtosOpcionais,
                        ) +
                          agregado.valorComissaoAplicadaFinal)
                          | currency
                      }}</span>
                    </div>
                    <vs-divider
                      class="mb-0 mt-1"
                      v-if="dadosProposta.exibirParticipacaoProposta"
                    />
                    <div
                      class="w-full flex justify-between mt-1"
                      v-if="dadosProposta.exibirParticipacaoProposta"
                    >
                      <span>{{ `${$t('Franquia')}` }}</span>
                      <span>{{
                        `${agregado.porcentagemParticipacao} ${$t('%')} ${$t(
                          'FIPE',
                        )}`
                      }}</span>
                      <span v-if="agregado.valorMinimoParticipacao > 0"
                        >, mínimo de
                        {{ agregado.valorMinimoParticipacao | currency }}</span
                      >
                    </div>
                    <vs-divider class="mb-5 mt-5" />
                  </div>
                </div>
              </div>

              <h4 class="subtituloDetalhes mb-4 hideInPrintVersion">
                {{ `${$t('Enviar')} ${$t('proposta')}` }}
              </h4>
              <div class="flex w-full justify-around mb-3 hideInPrintVersion">
                <vx-tooltip
                  active="false"
                  text="Fazer Download"
                  onclick="window.print()"
                >
                  <div class="flex p-1 justify-center">
                    <span class="icons-cotacao">
                      <vs-icon
                        icon-pack="feather"
                        icon="icon-download"
                        color="#93aabe"
                        size="medium"
                        click="#"
                      ></vs-icon>
                    </span>
                  </div>
                </vx-tooltip>
                <div class="flex p-1 justify-center">
                  <a
                    target="_blank"
                    :href="
                      returnLinkWhatsCliente(
                        dadosProposta.dadosVendedor.usuario,
                      )
                    "
                  >
                    <vx-tooltip text="Enviar por WhatsApp">
                      <span class="icons-cotacao">
                        <vs-icon
                          icon-pack="feather"
                          icon="icon-message-circle"
                          color="#93aabe"
                          size="medium"
                          click="#"
                        ></vs-icon>
                      </span>
                    </vx-tooltip>
                  </a>
                </div>
                <div
                  @click="copiarText(this)"
                  value="click to copy"
                  class="flex p-1 justify-center"
                >
                  <vx-tooltip text="Copiar">
                    <span class="icons-cotacao">
                      <vs-icon
                        icon-pack="feather"
                        icon="icon-copy"
                        color="#93aabe"
                        size="medium"
                        click="#"
                      ></vs-icon>
                    </span>
                  </vx-tooltip>
                </div>
              </div>
            </div>
            <div
              v-if="!isInterno && [5, 6].includes(dadosProposta.idStatus)"
              class="linkVistoriaDiv flex p-2 w-full fade-in justify-center hidePrintVersion"
            >
              <div class="wppConsultor" @click="redirectVistoriaV2()">
                <h4 class="text-white queroContratar">Continuar Vistoria</h4>
              </div>
            </div>
            <div
              v-if="!isInterno && [7].includes(dadosProposta.idStatus)"
              class="linkVistoriaDiv flex p-2 w-full fade-in justify-center hidePrintVersion"
            >
              <div class="wppConsultor" @click="redirectVistoriaV2()">
                <h4 class="mb-4 text-white queroContratar">
                  Visualizar vistoria
                </h4>
              </div>
            </div>
            <div
              v-if="[3, 4].includes(dadosProposta.idStatus) && !isInterno"
              class="status3e4 flex p-2 w-full fade-in justify-center hideInPrintVersion"
            >
              <div v-if="dadosProposta.idStatus == 3" class="wppConsultor">
                <h4 class="mb-4 text-white queroContratar">
                  {{
                    `${$t('Aguarde')} ${$t('Resultado')} ${$t('da')} ${$t(
                      'Vistoria',
                    )}`
                  }}
                </h4>
              </div>
              <div v-if="dadosProposta.idStatus == 4" class="wppConsultor">
                <h4 class="mb-4 text-white queroContratar">
                  {{ `${$t('Proposta')} ${$t('Finalizada')}` }}
                </h4>
              </div>
            </div>
            <div
              v-if="
                (propostaVencida == false || aprovarPropostasVencidas) &&
                dadosProposta.idStatus == 1 &&
                isInterno == false
              "
              class="hideInPrintVersion"
              button
            >
              <vs-divider class="mb-5" />

              <vs-card>
                <vs-alert
                  v-if="dadosProposta.cupom"
                  color="success"
                  active="true"
                  class="mt-1 mb-3"
                  style="height: auto !important"
                >
                  {{
                    `${$t('O')} ${$t('cupom')} ${dadosProposta.cupom} ${$t(
                      'foi',
                    )} ${$t('aplicado')}!`
                  }}
                </vs-alert>

                <h5 class="text-center mt-3 mb-6 subtituloDetalhes mb-4">
                  {{ `${$t('Cupom')} ${$t('de')} ${$t('desconto')}` }}
                </h5>

                <div>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="cupom"
                    id="input-cupom"
                    autocomplete="off"
                    placeholder="Digite aqui o cupom"
                    v-model="cupomDesconto"
                    @keyup="mascaraCupom($event)"
                    :danger="dangerCupomDesconto"
                    danger-text="Informe o cupom"
                  />
                </div>
                <div class="mt-3">
                  <vs-button
                    color="dark"
                    type="gradient"
                    class="w-full"
                    @click="applyDesconto()"
                  >
                    {{ `${$t('Aplicar')} ${$t('desconto')}` }}
                  </vs-button>
                </div>
              </vs-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="container avisoLeilao mb-5 pt-8 pb-8">
      <p class="flex text-black justify-center">
        {{
          `${$t('Para')} ${$t('veículos')} ${$t('de')} ${$t('Leilão')}, ${$t(
            'consulte',
          )} ${$t('nosso')} ${$t('representante')} ${$t('para')} ${$t(
            'obter',
          )} ${$t('informações')} ${$t('sobre')} ${$t('o')} ${$t('valor')} ${$t(
            'da',
          )} ${$t('indenização')}.`
        }}
      </p>
    </div>
    <footer class="p-4 pagebreak-inside-avoid">
      <div class="container">
        <div class="">
          <div id="Consultor+WPP" class="footerDivStyle">
            <div id="Consultor" class="flex justify-between items-center">
              <vs-avatar
                size="80px"
                :text="nomeAvatar"
                text-size="100%"
                color="rgb(59, 59, 59)"
                style="font-size: 50px"
              />
              <div>
                <h5 class="text-white">{{ $t('Consultor') }}</h5>
                <h1 class="text-white">
                  {{ dadosProposta.dadosVendedor.usuario }}
                </h1>
                <h5 class="text-white">
                  {{ dadosProposta.dadosVendedor.usuarioEmail }}
                </h5>
              </div>
            </div>
            <div class="boxWpp mt-3 sm:mt-0">
              <a target="_blank" :href="returnLinkWhatsVendedor()">
                <div class="whatsAppDiv flex pr-6 pl-3 justify-between fade-in">
                  <div>
                    <img
                      src="../../assets/images/pages/wpp-icon.png"
                      width="50"
                    />
                  </div>
                  <div class="wppConsultor pt-1 pb-1 flex">
                    <p class="wppTexto text-white">
                      {{ `${$t('WhatsApp')} ${$t('do')} ${$t('Consultor')}` }}
                    </p>
                    <p class="wppNumero text-white">
                      {{ dadosProposta.dadosVendedor.telefone }}
                    </p>
                  </div>
                </div></a
              >
            </div>
          </div>
        </div>
      </div>

      <div class="container rodape">
        <vs-divider color="#93aabe" />
        <div class="flex direction-row items-center gap-3">
          <h5 class="text-white cotacaoFooter">
            {{
              `${$t('Proposta')} ${$t('criada')} ${$t(
                'em',
              )} ${ajustaDataHoraUtc(dadosProposta.createdAt)}`
            }}
          </h5>
          <p
            class="showDesk"
            v-if="
              (dadosProposta.idStatus === statusCotacao.EM_ABERTO ||
                dadosProposta.idStatus ===
                  statusCotacao.EM_PROCESSO_VISTORIA) &&
              exibeValidadeNaProposta
            "
          >
            <span
              :class="`con-vs-chip ${
                propostaVencida != true
                  ? 'bg-success'
                  : this.aprovarPropostasVencidas
                  ? 'bg-warning'
                  : 'bg-danger'
              } text-white flex items-center`"
              style="display: inline-block; float: none; padding-left: 10px"
              >{{ $t('válida') }} {{ $t('até') }}
              {{ calculaValidadeProposta(dadosProposta.createdAt) }}</span
            >
          </p>
        </div>
        <p
          class="showMobile"
          v-if="
            dadosProposta.idStatus === statusCotacao.EM_ABERTO ||
            dadosProposta.idStatus === statusCotacao.EM_PROCESSO_VISTORIA
          "
        >
          <span
            :class="`con-vs-chip ${
              propostaVencida != true
                ? 'bg-success'
                : this.aprovarPropostasVencidas
                ? 'bg-warning'
                : 'bg-danger'
            } text-white flex items-center`"
            style="display: inline-block; float: none; padding-left: 10px"
            >{{ $t('válida') }} {{ $t('até') }}
            {{ calculaValidadeProposta(dadosProposta.createdAt) }}</span
          >
        </p>
      </div>
    </footer>
    <div
      v-if="
        dadosProposta.idStatus == 1 &&
        !dadosProposta.dataAceite &&
        isInterno == false
      "
      class="whatsAppDiv fixed-bottom showMobile"
    >
      <div class="wppConsultor hideInPrintVersion" @click="popupActive = true">
        <h4 class="text-white queroContratar">
          {{ `${$t('Quero')} ${$t('Contratar')}` }}
        </h4>
      </div>
    </div>
    <div
      v-if="!isInterno && [5, 6].includes(dadosProposta.idStatus)"
      class="linkVistoriaDiv fixed-bottom showMobile"
    >
      <div class="wppConsultor" @click="redirectVistoriaV2()">
        <h4 class="text-white queroContratar">
          {{ `${$t('Continuar')} ${$t('Vistoria')}` }}
        </h4>
      </div>
    </div>

    <div
      v-if="[3, 4].includes(dadosProposta.idStatus) && !isInterno"
      class="status3e4 fixed-bottom showMobile"
    >
      <div v-if="dadosProposta.idStatus == 3" class="wppConsultor">
        <h4 class="mb-4 text-white queroContratar">
          {{
            `${$t('Aguarde')} ${$t('Resultado')} ${$t('da')} ${$t('Vistoria')}`
          }}
        </h4>
      </div>
      <div v-if="dadosProposta.idStatus == 4" class="wppConsultor">
        <h4 class="mb-4 text-white queroContratar">
          {{ `${$t('Proposta')} ${$t('Finalizada')}` }}
        </h4>
      </div>
    </div>

    <vs-popup
      class="holamundo"
      title="Confirmação de Contratação"
      :active.sync="popupActive"
    >
      <div v-if="confirmarDados == false">
        <p>
          {{
            `${$t('Ao')} ${$t('clicar')} ${$t('em')} ${$t('"Confirmar",')} ${$t(
              'você',
            )} ${$t('será')} ${$t('direcionado')} ${$t('para')} ${$t('o')} ${$t(
              'nosso',
            )} ${$t('APP,')} ${$t('onde')} ${$t('poderá')} ${$t(
              'completar',
            )} ${$t('os')} ${$t('seus')} ${$t('dados')} ${$t('e')} ${$t(
              'fazer',
            )} ${$t('a')} ${$t('vistoria.')}`
          }}
        </p>
        <h4 class="my-4">
          {{
            `${$t('Fique')} ${$t('atento')} ${$t('aos')} ${$t(
              'seguintes',
            )} ${$t('pontos')}:`
          }}
        </h4>
        <p class="my-4">
          {{
            `${$t('Algumas')} ${$t('instruções')} ${$t('para')} ${$t(
              'tirar',
            )} ${$t('as')} ${$t('fotos')}:`
          }}
        </p>
        <ol style="list-style-type: inherit; margin-left: 15px">
          <li>
            {{
              `${$t('Escolha')} ${$t('um')} ${$t('local')} ${$t('bem')} ${$t(
                'iluminado',
              )}, ${$t('de')} ${$t('preferência')} ${$t('de')} ${$t(
                'dia',
              )}, ${$t('em')} ${$t('local')} ${$t('aberto')}`
            }}
          </li>
          <li>
            {{
              `${$t('Sempre')} ${$t('tire')} ${$t('fotos')} ${$t('com')} ${$t(
                'a',
              )} ${$t('visão')} ${$t('nítida')} ${$t('da')} ${$t('placa')} ${$t(
                'do',
              )} ${$t('veículo')}`
            }}
          </li>
          <li>
            {{
              `${$t('Vidros')} ${$t('e')} ${$t('portas')} ${$t('devem')} ${$t(
                'estar',
              )} ${$t('fechados')}`
            }}
          </li>
          <li>
            {{
              `${$t('Se')} ${$t('você')} ${$t('não')} ${$t('possui')} ${$t(
                'tanto',
              )} ${$t('domínio')} ${$t('e/ou')} ${$t('manuseio')} ${$t(
                'no',
              )} ${$t('celular')}, ${$t('peça')} ${$t('um')} ${$t(
                'amigo',
              )} ${$t('ou')} ${$t('parente')} ${$t('para')} ${$t('te')} ${$t(
                'ajudar',
              )}. ${$t('Lembrando')} ${$t('que')} ${$t('só')} ${$t(
                'você',
              )} ${$t('pode')} ${$t('assinar')} ${$t('e')} ${$t('sair')} ${$t(
                'na',
              )} ${$t('selfie')}.`
            }}
          </li>
        </ol>
        <vs-button
          class="mt-5 w-full"
          color="primary"
          type="gradient"
          icon-pack="feather"
          icon="icon-check"
          icon-before
          size="large"
          @click="clickEntendi()"
          >{{ `${$t('ENTENDI')}` }}</vs-button
        >
        >
      </div>
      <div v-if="confirmarDados == true">
        <div v-if="!showBoxFinanceiro">
          <vs-alert
            color="warning"
            title="Atenção!!"
            active="true"
            class="my-3 mb-10"
            style="height: auto !important"
            >{{
              `${$t('Esse')} ${$t('passo')} ${$t('é')} ${$t('muito')} ${$t(
                'importante',
              )}, ${$t('para')} ${$t('continuar')} ${$t('confirme')} ${$t(
                'seus',
              )} ${$t('dados')}!`
            }}
          </vs-alert>
          <form role="form" @submit.stop.prevent>
            <div class="vx-col container-radio">
              <vs-radio
                v-for="item in tiposDePessoa"
                :key="item.idTipoPessoa"
                v-model="tipoDePessoa"
                vs-name="btnRadioTipoPessoa"
                :vs-value="item.idTipoPessoa"
                class="w-full mb-3"
              >
                {{ item.tipoPessoa }}
              </vs-radio>
            </div>

            <div v-if="tipoDePessoa == 1">
              <vs-input
                class="w-full no-icon-border mb-10"
                name="CPF/CNPJ"
                id="CPF"
                autocomplete="off"
                aria-autocomplete="none"
                role="presentation"
                label-placeholder="CPF"
                v-model="formConfirmacao.cpfcnpj"
                v-validate="{ required: true, min: 14 }"
                :state="validateState('CPF')"
                :danger="validateClass('CPF')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                v-mask="'###.###.###-##'"
                icon-pack="feather"
                icon="icon-user-check"
                icon-no-border
                :disabled="!isCpfCanChange()"
              />
            </div>
            <div v-else>
              <vs-input
                class="w-full no-icon-border mb-10"
                name="CNPJ"
                id="CNPJ"
                autocomplete="off"
                aria-autocomplete="none"
                role="presentation"
                label-placeholder="CNPJ"
                v-model="formConfirmacao.cpfcnpj"
                v-validate="{ required: true, min: 18 }"
                :state="validateState('CNPJ')"
                :danger="validateClass('CNPJ')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                v-mask="'##.###.###/####-##'"
                icon-pack="feather"
                icon="icon-briefcase"
                icon-no-border
                :disabled="!isCpfCanChange()"
              />
            </div>

            <vs-input
              class="w-full no-icon-border mb-10"
              label-placeholder="Nome"
              v-model="formConfirmacao.nome"
              name="Nome"
              v-validate="{ required: true }"
              :state="validateState('Nome')"
              :danger="validateClass('Nome')"
            />

            <vs-input
              name="email"
              icon="icon icon-mail"
              icon-pack="feather"
              label-placeholder="E-mail"
              v-model="formConfirmacao.email"
              class="w-full no-icon-border mb-10"
              v-validate="{ email: true }"
              :state="validateState('email')"
              :danger="validateClass('email')"
            />

            <vs-input
              class="w-full no-icon-border mb-10"
              name="Celular"
              id="Celular"
              label-placeholder="Celular"
              v-model="formConfirmacao.celular"
              v-validate="{ required: true, min: 15 }"
              :state="validateState('Celular')"
              :danger="validateClass('Celular')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-mask="'(##) #####-####'"
              icon-pack="feather"
              icon="icon-smartphone"
              icon-no-border
            />

            <div v-if="tipoDePessoa == 1">
              <vs-input
                class="w-full no-icon-border mb-10"
                label-placeholder="RG"
                v-model="formConfirmacao.rgIe"
                name="RG"
                key="RG"
                v-validate="{ required: true }"
                :state="validateState('RG')"
                :danger="validateClass('RG')"
              />

              <vs-input
                class="w-full no-icon-border mb-10"
                label-placeholder="Data de Nascimento"
                v-mask="'##/##/####'"
                key="dataNascimento"
                v-model="formConfirmacao.dataNascimento"
                name="Data de Nascimento"
                v-validate="{ required: true, date_format: 'dd/MM/yyyy' }"
                :state="validateState('Data de Nascimento')"
                :danger="validateClass('Data de Nascimento')"
              />
            </div>
            <div v-else>
              <vs-input
                class="w-full no-icon-border mb-10"
                label-placeholder="Inscrição Estadual"
                v-model="formConfirmacao.rgIe"
                name="Inscrição Estadual"
                key="RGIE"
                v-validate="{ required: true }"
                :state="validateState('Inscrição Estadual')"
                :danger="validateClass('Inscrição Estadual')"
              />

              <vs-input
                class="w-full no-icon-border mb-10"
                label-placeholder="Representante Legal"
                v-model="formConfirmacao.representanteLegal"
                name="Nome Completo Represente Legal"
                key="representanteLegal"
                v-validate="{ required: true }"
                :state="validateState('Nome Completo Represente Legal')"
                :danger="validateClass('Nome Completo Represente Legal')"
              />

              <vs-input
                class="w-full no-icon-border mb-10"
                label-placeholder="Cpf do Representante"
                v-mask="'###.###.###-##'"
                key="cpfRepresentante"
                v-model="formConfirmacao.cpfRepresentante"
                name="Cpf do Representante"
                v-validate="{ required: true, min: 14 }"
                :state="validateState('Cpf do Representante')"
                :danger="validateClass('Cpf do Representante')"
              />
            </div>

            <!-- selecionar notificações
            <hr class="my-6" />
            <h5 class="my-4">Receber Notificações por:</h5>

            <div class="vx-row">
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <vs-checkbox
                  switch
                  v-model="formConfirmacao.canaisComunicacao"
                  :vs-value="'WhatsApp'"
                  >WhatsApp
                </vs-checkbox>
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <vs-checkbox
                  switch
                  v-model="formConfirmacao.canaisComunicacao"
                  :vs-value="'Email'"
                  >Email
                </vs-checkbox>
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <vs-checkbox
                  switch
                  v-model="formConfirmacao.canaisComunicacao"
                  :vs-value="'SMS'"
                  >SMS
                </vs-checkbox>
              </div>
            </div>-->

            <hr class="my-6" />
            <h5 class="my-4">{{ `${$t('Endereço')}:` }}</h5>

            <!-- Endereço -->
            <div class="vx-row">
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <vs-input
                  class="w-full"
                  label-placeholder="CEP"
                  v-mask="'##.###-###'"
                  v-model="formConfirmacao.cep"
                  name="CEP"
                  @keyup.native="keymonitor"
                  v-validate="{ required: true, min: 10 }"
                  :state="validateState('CEP')"
                  :danger="validateClass('CEP')"
                />
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <vs-input
                  class="w-full"
                  label-placeholder="Endereço"
                  v-model="formConfirmacao.endereco"
                  name="Endereço"
                  v-validate="{ required: true }"
                  :state="validateState('Endereço')"
                  :danger="validateClass('Endereço')"
                />
              </div>
              <div class="vx-col sm:w-1/6 w-full mb-2">
                <vs-input
                  class="w-full"
                  label-placeholder="Número"
                  v-model="formConfirmacao.numero"
                  name="Número"
                  v-validate="{ required: true }"
                  :state="validateState('Número')"
                  :danger="validateClass('Número')"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full mb-2">
                <vs-input
                  class="w-full"
                  label-placeholder="Complemento"
                  v-model="formConfirmacao.complemento"
                  name="Complemento"
                  :state="validateState('Complemento')"
                  :danger="validateClass('Complemento')"
                />
              </div>
            </div>
            <div class="vx-row">
              <!-- Bairro -->
              <div class="vx-col sm:w-1/3 w-full mb-2 mt-1">
                <vs-input
                  class="w-full"
                  label-placeholder="Bairro"
                  v-model="formConfirmacao.bairro"
                  name="Bairro"
                  v-validate="{ required: true }"
                  :state="validateState('Bairro')"
                  :danger="validateClass('Bairro')"
                />
              </div>

              <!-- Estado -->
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <label class="label-select">{{ `${$t('Estado')}` }}</label>
                <v-select
                  :options="listEstados"
                  v-model="formConfirmacao.estado"
                  name="Estado"
                  id="Estado"
                  v-validate="{ required: true }"
                  :class="{ 'error-select': validateClass('Estado') }"
                  @input="clearCidade"
                >
                </v-select>
              </div>

              <!-- Cidade -->
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <label class="label-select">{{ `${$t('Cidade')}` }}</label>
                <v-select
                  :options="listCidade"
                  v-model="formConfirmacao.cidade"
                  name="Cidade"
                  id="Cidade"
                  v-validate="{ required: true }"
                  :reduce="(item) => item.label"
                  :class="{ 'error-select': validateClass('Cidade') }"
                >
                </v-select>
              </div>
            </div>

            <!-- Alert -->
          </form>

          <vs-button
            class="mt-5 w-full"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-check"
            icon-before
            size="large"
            @click="contratar()"
            >{{ `${$t('CONFIRMAR')}` }}</vs-button
          >
        </div>
        <div v-else>
          <h5 class="my-4">{{ `${$t('Financeiro')}` }}</h5>

          <!-- Financeiro -->
          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <label for="" class="vs-select--label">{{
                `${$t('Forma')} ${$t('de')} ${$t('Pagamento')} - 1 ${$t(
                  'Parcela',
                )}`
              }}</label>
              <v-select
                :options="formaPagamentoProdutos.entrada.opcoes"
                name="Forma de Pagamento 1 Parcela"
                id="Forma de Pagamento 1 Parcela"
                v-model="formConfirmacao.idFormaPagamentoAVista"
                v-validate="{ required: true }"
                :reduce="(item) => item.value"
                label="text"
                :class="{
                  'error-select': validateClass('Forma de Pagamento 1 Parcela'),
                }"
                @input="aoSelecionarFormaPagamento('entrada', $event)"
              >
              </v-select>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <label for="" class="vs-select--label">{{
                `${$t('Forma')} ${$t('de')} ${$t('Pagamento')} - ${$t(
                  'Mensal',
                )}`
              }}</label>
              <v-select
                :options="formaPagamentoProdutos.mensal.opcoes"
                name="Forma Pagamento Mensal"
                id="Forma Pagamento Mensal"
                v-model="formConfirmacao.idFormaPagamentoMensal"
                v-validate="{ required: true }"
                :reduce="(item) => item.value"
                label="text"
                :class="{
                  'error-select': validateClass('Forma Pagamento Mensal'),
                }"
                @input="aoSelecionarFormaPagamento('mensal', $event)"
              >
              </v-select>
            </div>
          </div>

          <div
            class="vx-row"
            v-if="formaPagamentoProdutos.dinheiro.opcoes.length > 0"
          >
            <div class="vx-col w-full mb-2">
              <label for="" class="vs-select--label"
                >Valores Pagos em Dinheiro</label
              >

              <p class="text-sm text-gray-600 mb-1">
                <strong>Produtos:</strong>
                {{
                  formaPagamentoProdutos.dinheiro.opcoes
                    .filter((op) => op.nomeProduto)
                    .map((op) => op.nomeProduto)
                    .filter((v, i, arr) => arr.indexOf(v) === i)
                    .join(', ')
                }}
              </p>
              <v-select
                :options="formaPagamentoProdutos.dinheiro.opcoes"
                name="Forma Pagamento Dinheiro"
                id="Forma Pagamento Dinheiro"
                v-model="formConfirmacao.idFormaPagamentoDinheiro"
                v-validate="{ required: true }"
                :reduce="(item) => item.value"
                label="text"
                :class="{
                  'error-select': validateClass('Forma Pagamento Mensal'),
                }"
              >
              </v-select>
            </div>
          </div>
          <div class="vx-row">
            <div
              v-if="
                !diasVencimentoTypeCalendar && exibeDiaVencimentoMensalidade
              "
              class="vx-col w-full mb-2"
            >
              <label for="" class="vs-select--label"
                >Dia de Vencimento da Mensalidade</label
              >
              <v-select
                :options="diasVencimento"
                name="Dia de Vencimento"
                id="Dia de Vencimento"
                v-model="formConfirmacao.diaVencimentoMensalidade"
                v-validate="{ required: true }"
                :reduce="(item) => item"
                :class="{
                  'error-select': validateClass('Dia de Vencimento'),
                }"
              >
              </v-select>
            </div>
            <div
              v-if="diasVencimentoTypeCalendar && exibeDiaVencimentoMensalidade"
              class="mt-5 w-full vx-col"
            >
              <h5>Dia de Vencimento Mensal</h5>

              <div class="vx-col mb-2 mt-3">
                <DateRadio
                  :diasDisponiveis="diasVencimento"
                  :diaJaDefinido="dadosProposta.diaVencimentoMensalidade"
                  @diaSelecionado="diaSelecionado($event)"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-wrap justify-between my-5">
            <vs-alert
              v-if="$validator.errors.all().length > 0"
              color="danger"
              title="Atenção!!"
              active="true"
              class="my-3"
              style="height: auto !important"
            >
              <ul>
                <li
                  class="mb-2"
                  v-for="error in $validator.errors.all()"
                  :key="error.id"
                >
                  {{ error }}
                </li>
              </ul>
            </vs-alert>
          </div>
          <vs-button
            class="mt-5 w-full"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-check"
            icon-before
            size="large"
            @click="contratar()"
            >{{
              `${$t('CONFIRMAR')} ${$t('e')} ${$t('IR')} ${$t('PARA')} ${$t(
                'A',
              )} ${$t('VISTORIA')}`
            }}</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <div
      class="pagebreak-inside-avoid"
      v-if="
        dadosProposta.dadosAssociacao.contraCapaProposta &&
        !empresasNaoImprimeCapa.includes(dadosProposta.idEmpresa)
      "
    >
      <img
        class="capaImpressao showInPrintVersion pagebreak-inside-avoid"
        :src="dadosProposta.dadosAssociacao.contraCapaProposta"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import service from '../../services';
import functions from '../../utils/functions';
import locale from './../../locale';
import VxTooltip from '../../layouts/components/vx-tooltip/VxTooltip.vue';
import cpfCnpj from '../../services/cpfCnpj';
import notify from './../../utils/notify';
import { setTimeout } from 'timers';
import vSelect from 'vue-select';
import {
  getSelectsCidades,
  getSelectsEstados,
} from './../../services/ufMunicipio';
import { obterParticipacaoProdutoInvoice } from '../../services/cotacao';
import { STATUS_COTACAO } from '../../commons/status-cotacao';
import DateRadio from '../../components/date-radio/DateRadio.vue';
import { TIPO_PRODUTO } from '../../commons/dicionarioTipoProduto';
import { decryptData } from '../../services/decryptData';
import { BP } from '../../commons/constant/empresasBp';
import { normalizaObjFormasPagamento } from '../../services/formasPagamento';
import { getTranslate } from '@/services/translate/translate';
import { TIPO_PAGAMENTO } from '../../commons/constant/tipo-pagamento';

const URL_VISTORIA = 'https://vistoria.bemprotege.com.br';
const URL_VISTORIA_BPVCMENSAL = 'https://vistoria.bpmensal.com.br';

export default {
  name: 'invoiceBP',
  data() {
    return {
      functions: functions,
      existeProdutoOpcionalVeiculoSelecionado: null,
      existeProdutoOpcionalAgregadoSelecionado: null,
      linkRedirect: null,
      idRegistroFinanceiro: null,
      contadorBuscaRegistro: null,
      retornoAPI: null,
      retornoRegistroFinanceiro: null,
      formasPagamentosGerais: [],
      showBoxFinanceiro: false,
      exibeFinanceiro: false,
      implementos: [],
      agregados: [],
      opcionais: [],
      produtosOpcionais: [],
      produtosRemovidos: [],
      produtosObrigatorios: [],
      switchIncluiProtecao: [],
      produtosvalorMensal: [],
      dadosProposta: null,
      produtosRecuperado: [],
      confirmarDados: false,
      arrayDuplicados: [],
      aprovarPropostasVencidas: null,
      dangerCupomDesconto: false,
      cupomDesconto: null,
      propostaVencida: false,
      popupActive: false,
      nomeAvatar: '',
      cpfDuplicado: false,
      temDesconto: false,
      temDescontoEntrada: false,
      CPFdeOutroAssociado: false,
      tipoDePessoa: null,
      diasVencimento: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      dadosFinanceiros: {},
      formasPagamentoEncontradas: false,
      formaPagamentoProdutos: [],
      formConfirmacao: {
        cpfcnpj: null,
        celular: null,
        email: null,
        nome: null,
        rgIe: null,
        dataNascimento: null,
        representanteLegal: null,
        cpfRepresentante: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        estado: null,
        cidade: null,
        canaisComunicacao: ['WhatsApp', 'Email', 'SMS'],
        diaVencimentoMensalidade: null,
        idFormaPagamentoAVista: {},
        idFormaPagamentoMensal: {},
        idFormaPagamentoDinheiro: {},
      },
      tiposDePessoa: [
        { idTipoPessoa: 1, tipoPessoa: 'Pessoa Física' },
        { idTipoPessoa: 2, tipoPessoa: 'Pessoa Jurídica' },
      ],
      opcaoFgtsEscolhida: null,
      exibeValidadeNaProposta: null,
      listEstados: [],
      listCidade: [],
      isRecalculating: false,
      statusCotacao: STATUS_COTACAO,
      empresa: BP,
      empresasNaoImprimeCapa: [126],
      empresasNaoImprimePriParcela: [121],
      idsAgregadosUnificados: [],
      exibeDiaVencimentoMensalidade: true,
      TIPO_CARTAO_CREDITO: 'Cartão de Crédito',
    };
  },
  computed: {
    valorMensalidadeDiferenca: function () {
      const _valorMensalidadeDiferenca =
        this.somaValorTotalOriginal(
          this.produtosObrigatorios,
          this.produtosOpcionais,
        ) + this.somaTotaisAgregados(true, 'original');

      return _valorMensalidadeDiferenca;
    },
    valorMensalidade: function () {
      const { comissaoAplicada } = this.dadosProposta;

      const _valorMensalidade = this.somaValorTotalMes(
        this.produtosObrigatorios,
        this.produtosOpcionais,
      );

      const valorFinal =
        _valorMensalidade + Number(this.somaTotaisAgregados(true));

      return comissaoAplicada
        ? valorFinal + (valorFinal * comissaoAplicada) / 100
        : valorFinal;
    },

    valorMensalidadeSemAgregado: function () {
      const { comissaoAplicada } = this.dadosProposta;

      const _valorMensalidade = this.somaValorTotalMes(
        this.produtosObrigatorios,
        this.produtosOpcionais,
      );

      const valorFinalVeiculo = comissaoAplicada
        ? _valorMensalidade + (_valorMensalidade * comissaoAplicada) / 100
        : _valorMensalidade;

      const valorFinal = valorFinalVeiculo;

      return valorFinal;
    },
    valorEntradaDiferenca: function () {
      const _valorEntradaDiferenca =
        this.somaValorTotalValoresAvistaOriginal(
          this.produtosObrigatorios,
          this.produtosOpcionais,
        ) + this.somaTotaisAgregados(false, 'original');

      return _valorEntradaDiferenca;
    },
    valorEntrada: function () {
      const _valorEntrada =
        this.somaValorTotalValoresAvista(
          this.produtosObrigatorios,
          this.produtosOpcionais,
        ) + this.somaTotaisAgregados(false, 'final');
      return _valorEntrada;
    },
  },
  methods: {
    async translate(companyId) {
      const translate = await getTranslate(companyId);
      if (translate) {
        const nameDefaultLocale = `defaultLabels`;
        this.$i18n.mergeLocaleMessage(nameDefaultLocale, translate);
        this.$i18n.locale = nameDefaultLocale;
      }
    },
    verificaDiferencaValoresMensalidade() {
      if (this.valorMensalidade >= this.valorMensalidadeDiferenca) return;

      return this.valorMensalidade != this.valorMensalidadeDiferenca;
    },
    verificaDiferencaValoresEntrada() {
      return this.valorEntrada != this.valorEntradaDiferenca;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    confirmaCpfOutroAssociado() {
      this.formConfirmacao.unificarAssociado = true;
      this.formConfirmacao.idSelecionadoMescla = undefined;
      this.contratar();
    },
    selecionarItemDuplicado(item) {
      this.formConfirmacao.idSelecionadoMescla = item.id_prospect;

      this.arrayDuplicados.forEach((element) => {
        element.selecionado = false;
      });

      item.selecionado = true;
    },
    filtraProdutosObrigatorios() {
      this.produtosObrigatorios.filter(
        (produto) => produto.produtoVisivel == true,
      );
    },
    filtraProdutosOpcionais() {
      this.produtosOpcionais.filter((produtos) => {
        return produtos.produtoVisivel;
      });
    },
    filtraProdutosMensais(mensal) {
      if (mensal == true)
        return this.dadosProposta.produtos.filter((x) => x.isMensal == true);
    },
    calculaValidadeProposta(data) {
      const dataCriacaoProposta = data;
      let qtdDiasValidadeProposta;

      const propostaEmAberto =
        this.dadosProposta.idStatus === this.statusCotacao.EM_ABERTO;

      if (propostaEmAberto) {
        qtdDiasValidadeProposta =
          this.dadosProposta.dadosAssociacao.qtdDiasVencimentoPropostaEmAberto +
          1;
      }

      const propostaEmVistoria =
        this.dadosProposta.idStatus === this.statusCotacao.EM_PROCESSO_VISTORIA;

      if (propostaEmVistoria) {
        qtdDiasValidadeProposta =
          this.dadosProposta.dadosAssociacao
            .qtdDiasVencimentoPropostaEmVistoria + 1;
      }

      if (qtdDiasValidadeProposta) {
        const _dataValidade = moment(dataCriacaoProposta).add(
          qtdDiasValidadeProposta,
          'days',
        );

        if (moment(_dataValidade).diff(moment(), 'days') < 0) {
          this.propostaVencida = true;
        }

        if (this.propostaVencida && this.aprovarPropostasVencidas) {
          return moment().add(7, 'days').format('DD/MM/YYYY');
        }

        const _validadeProposta = `${moment(_dataValidade).format(
          'DD/MM/YYYY',
        )} | ${moment(_dataValidade).diff(moment(), 'days')} dias`.replace(
          '-',
          '',
        );

        return _validadeProposta;
      }

      const ultimoDiaMes = moment(data).endOf('month');

      if (moment(ultimoDiaMes).diff(moment(), 'days') < 0) {
        this.propostaVencida = true;
      }

      if (this.propostaVencida && this.aprovarPropostasVencidas) {
        return moment().add(7, 'days').format('DD/MM/YYYY');
      }

      const _ultimoDiaValidade = `${moment(ultimoDiaMes).format(
        'DD/MM/YYYY',
      )} | ${moment(ultimoDiaMes).diff(moment(), 'days')} dias`.replace(
        '-',
        '',
      );

      return _ultimoDiaValidade;
    },
    filtraBeneficios(tipo) {
      var aux = this.dadosProposta.beneficios.filter((x) => x.tipo == tipo);
      return aux;
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY HH:mm');
    },
    produtosAvista() {
      var produtos = [];
      var aux = this.produtosObrigatorios
        .filter((x) => x.isMensal != true && x.visivelProposta == true)
        .map((item) => ({
          ...item,
          placa: this.dadosProposta.dadosVeiculo.placa,
          descricao: this.dadosProposta.dadosVeiculo.chassi,
        }));

      var aux2 = this.produtosOpcionais
        .filter(
          (x) =>
            x.isMensal != true &&
            x.selecionado == true &&
            x.visivelProposta == true,
        )
        .map((item) => ({
          ...item,
          placa: this.dadosProposta.dadosVeiculo.placa,
          descricao: this.dadosProposta.dadosVeiculo.chassi,
        }));

      const temAgregado = this.dadosProposta.agregado;
      const produtosAvistaAgregado = [];

      if (temAgregado) {
        this.agregados.forEach((item) => {
          const {
            produtosObrigatorios,
            produtosNaoObrigatorios,
            placa,
            descricao,
          } = item;

          const temAgregadosUnificados =
            this.agregados &&
            this.agregados.length > 0 &&
            this.agregados[0].unificarAgregado;

          const descricaoProduto = temAgregadosUnificados
            ? {
                descricao: 'Agregados',
              }
            : {
                placa,
                descricao,
              };

          produtosObrigatorios.forEach((item) => {
            if (!item.isMensal && item.selecionado) {
              const _produto = { ...item, ...descricaoProduto };
              produtosAvistaAgregado.push(_produto);
            }
          });

          produtosNaoObrigatorios.forEach((item) => {
            if (!item.isMensal && item.selecionado) {
              const _produto = { ...item, ...descricaoProduto };
              produtosAvistaAgregado.push(_produto);
            }
          });
        });
      }

      produtos = [...aux, ...aux2, ...produtosAvistaAgregado];
      return produtos;
    },
    continuarCotacao() {
      var objSend = {};
      objSend.idCotacao = this.dadosProposta.idProposta;
      this.$vs.loading();
      service
        .post('CotacaoAberta', 'gerarTokenContinar', objSend)
        .then((res) => {
          let linkRelativo = window.location.origin;

          linkRelativo = linkRelativo
            .replace('adm.', 'app.')
            .replace('8081', '8080');

          this.$vs.loading.close();

          let link = `${linkRelativo}/?idEmpresa=${
            this.dadosProposta.idEmpresa
          }&cpfcnpj=${this.formConfirmacao.cpfcnpj.replace('/', '')}&placa=${
            this.dadosProposta.dadosVeiculo.placa
          }`;

          if (res.data.token) {
            const passo8 = this.dadosProposta.idStatus == 5 ? '/8/0' : '';
            //localStorage.setItem('user-token', res.data.token);
            link = `${linkRelativo}/?idEmpresa=${this.dadosProposta.idEmpresa}&token=${res.data.token}&chave=${this.dadosProposta.chave}${passo8}`;
          }

          this.linkRedirect = link;
          if (
            this.dadosProposta.idStatus == 5 ||
            this.dadosProposta.idStatus == 6 ||
            (this.dadosProposta.idStatus == 1 && this.dadosProposta.dataAceite)
          ) {
            window.location = link;
          }
        })
        .catch(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível confirmar a Contratação',
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },

    contratar() {
      const objSend = { ...this.formConfirmacao };

      objSend.idCotacao = this.dadosProposta.idProposta;
      objSend.idEmpresa = this.dadosProposta.idEmpresa;
      objSend.dadosFinanceiros = this.formaPagamentoProdutos;

      if (objSend.estado) {
        objSend.estado = objSend.estado.label;
      }

      const _cpfCnpjValido =
        cpfCnpj.valida_cpf_cnpj(this.formConfirmacao.cpfcnpj) == false;

      if (_cpfCnpjValido) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Este CPF/CNPJ não é válido`,
          color: 'danger',
        });

        return;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          service
            .post('CotacaoAberta', 'aceiteProposta', objSend)
            .then((res) => {
              // Montagem Link Vistoria V1
              // ---------------------------
              // let linkRelativo = window.location.origin;
              // linkRelativo = linkRelativo
              //   .replace('adm.', 'app.')
              //   .replace('8081', '8080');

              this.$vs.loading.close();

              if (res.data.sucess == true) {
                if (this.showBoxFinanceiro == false)
                  this.showBoxFinanceiro = true;
                else this.redirectVistoriaV2();
              }
            })
            .catch(() => {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Não foi possível confirmar a Contratação',
                color: 'danger',
              });
              this.$vs.loading.close();
            });
        }
      });
    },
    somaValorTotal(produtos1, produtos2) {
      var total = 0;

      produtos1.forEach((element) => {
        if (element.isMensal == false) total = total + element.valorFinal;
      });

      produtos2.forEach((element) => {
        if (element.isMensal == false && element.selecionado == true)
          total = total + element.valorFinal;
      });

      return total;
    },
    somaValorTotalMes(arr1, arr2) {
      var total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal == true && element.excluido != true)
            total = total + element.valorFinal;
        });
      if (arr2 && arr2.length > 0)
        arr2.forEach((element) => {
          if (element.isMensal == true && element.selecionado == true)
            total = total + element.valorFinal;
        });
      return total;
    },
    somaValorTotalOriginal(arr1, arr2) {
      let total = 0;
      const { comissaoAplicada } = this.dadosProposta;

      const isValidArray = (array) => array && array.length > 0;

      if (isValidArray(arr1)) {
        arr1.forEach(({ isMensal, excluido, valor }) => {
          if (isMensal === true && excluido !== true) {
            total += valor;
          }
        });
      }

      if (isValidArray(arr2)) {
        arr2.forEach(({ isMensal, selecionado, valor }) => {
          if (isMensal === true && selecionado === true) {
            total += valor;
          }
        });
      }

      const totalComComissao = comissaoAplicada
        ? total + (total * comissaoAplicada) / 100
        : total;
      return totalComComissao;
    },
    somaValorTotalValoresAvista(arr1, arr2) {
      var total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal != true) total = total + element.valorFinal;
        });
      if (arr2 && arr2.length > 0)
        arr2.forEach((element) => {
          if (element.isMensal != true && element.selecionado == true)
            total = total + element.valorFinal;
        });
      return total;
    },
    somaValorTotalValoresAvistaAdesao(arr1, arr2) {
      var total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal != true && element.idTipoProduto == 1)
            total = total + element.valorFinal;
        });
      if (arr2 && arr2.length > 0)
        arr2.forEach((element) => {
          if (
            element.isMensal != true &&
            element.selecionado == true &&
            element.idTipoProduto == 1
          )
            total = total + element.valorFinal;
        });
      return total;
    },

    /**
     * @desc Calcula a soma do Primeira Parcela e mensalidade para agregados
     *
     * @param {Boolean} Boolean -  true ou false
     * @param {String} String - final ou original
     *
     * @returns {Float} valor total
     */
    somaTotaisAgregados(mensal = true, tipoValor = 'final') {
      const temAgregado =
        this.dadosProposta.agregado && this.agregados.length > 0;

      if (!temAgregado) return 0;

      const agregadosUnificados = this.agregados[0].unificarAgregados;
      const calcularTotalProdutos = (produtos) =>
        produtos.reduce((acc, produto) => {
          const isMensal = produto.hasOwnProperty('isMensal')
            ? produto['isMensal']
            : produto['ismensal'];

          const selecionado = produto['selecionado'];

          const { valor, valorFinal } = produto;

          const valorProduto = tipoValor === 'final' ? valorFinal : valor;

          const deveIncluir = isMensal === mensal && selecionado;

          if (deveIncluir) acc += valorProduto;

          return acc;
        }, 0);

      if (agregadosUnificados) {
        const { produtosObrigatorios, produtosOpcionais } = this.agregados[0];
        return (
          calcularTotalProdutos(produtosObrigatorios) +
          calcularTotalProdutos(produtosOpcionais)
        );
      }

      const total = this.agregados.reduce((valorTotal, agregado) => {
        const {
          produtosObrigatorios,
          produtosOpcionais,
          valorComissaoAplicadaFinal,
        } = agregado;
        valorTotal += calcularTotalProdutos(produtosObrigatorios);
        valorTotal += calcularTotalProdutos(produtosOpcionais);

        const valorCommissao = valorComissaoAplicadaFinal
          ? valorComissaoAplicadaFinal
          : 0;

        valorTotal += valorCommissao;

        return valorTotal;
      }, 0);

      return total;
    },
    somaValorTotalValoresAvistaOriginal(arr1, arr2) {
      var total = 0;

      if (arr1 && arr1.length > 0) {
        arr1.forEach((element) => {
          if (!element.isMensal) {
            total = total + element.valor;
          }
        });
      }

      if (arr2 && arr2.length > 0) {
        arr2.forEach((element) => {
          if (!element.isMensal && element.selecionado) {
            total = total + element.valor;
          }
        });
      }

      return total;
    },
    calcDescontoMensal() {
      const produtos = this.dadosProposta.produtos;
      const desconto =
        this.somaValorSubTotalMes(produtos) - this.somaValorTotalMes(produtos);

      return desconto;
    },
    somaValorDesconto(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal != true) total = total + element.descontoConcedido;
      });
      return total;
    },
    marcaProdutosCarregamento() {
      this.produtosOpcionais.forEach((item) => {
        if (item.selecionado) {
          if (!item.sobreporOutrosProdutos) {
            return;
          }
          var prodssobreporOutrosProdutos =
            item.sobreporOutrosProdutos.split(',');
          prodssobreporOutrosProdutos.forEach((element) => {
            this.produtosObrigatorios.forEach((elementSel, index) => {
              if (elementSel.idProduto == element) {
                if (item.selecionado == true) {
                  this.produtosRemovidos.push(elementSel);
                  elementSel.excluido = true;
                } else {
                  this.produtosRemovidos.splice(index, 1);
                  elementSel.excluido = false;
                }
              }
            });
          });
        }
      });
    },
    async selecionaProduto(item, selecionado) {
      try {
        this.isRecalculating = true;
        const produtosAtulizar = [];

        if (item.sobreporOutrosProdutos) {
          //item é o objeto do produto
          const podeSobreporOutrosProdutos =
            item.sobreporOutrosProdutos.split(',');

          podeSobreporOutrosProdutos.forEach((element) => {
            //podeSobreporOutrosProdutos é o arrey de ids a serem sobrepostos e element é o id iterado
            this.produtosOpcionais.forEach((elementSel) => {
              if (element == elementSel.idProduto) {
                if (
                  item.selecionado == true &&
                  elementSel.selecionado == true
                ) {
                  elementSel.selecionado = false;

                  const prodSobreposto = {
                    idProposta: this.dadosProposta.idProposta,
                    acao:
                      elementSel.selecionado === false
                        ? 'remover'
                        : 'adicionar',
                    idProduto: elementSel.idProduto,
                    valorFinal: elementSel.valorFinal,
                  };

                  produtosAtulizar.push(prodSobreposto);
                }
              }
            });
          });
        }

        const idsProdutosLinkados = item.produtosLinkados.split(',');
        idsProdutosLinkados.forEach((idLink) => {
          if (idLink) {
            this.produtosOpcionais.forEach((element) => {
              if (idLink == element.idProduto) {
                element.selecionado = selecionado == false ? false : true;
                const _produto = {
                  idProposta: this.dadosProposta.idProposta,
                  acao: element.selecionado === true ? 'adicionar' : 'remover',
                  idProduto: element.idProduto,
                  valorFinal: element.valorFinal,
                };
                produtosAtulizar.push(_produto);
              }
            });
          }
        });

        if (item.sobreporOutrosProdutos) {
          var prodssobreporOutrosProdutos =
            item.sobreporOutrosProdutos.split(',');
          prodssobreporOutrosProdutos.forEach((element) => {
            this.produtosObrigatorios.forEach((elementSel, index) => {
              if (elementSel.idProduto == element) {
                if (item.selecionado == true) {
                  this.produtosRemovidos.push(elementSel);
                  elementSel.excluido = true;
                } else {
                  this.produtosRemovidos.splice(index, 1);
                  elementSel.excluido = false;
                }
              }
            });
          });
        }

        if (item.produtosComplementares) {
          const idsProdutosComplementares =
            item.produtosComplementares.split(',');
          idsProdutosComplementares.forEach((idComplemento) => {
            if (idComplemento) {
              this.produtosOpcionais.forEach((element) => {
                if (idComplemento == element.idProduto) {
                  element.exibir = true;
                }
              });
            }
          });
        }

        const itemArray = {};
        itemArray.acao = selecionado == true ? 'adicionar' : 'remover';
        itemArray.idProduto = item.idProduto;
        itemArray.valorFinal = item.valorFinal;
        produtosAtulizar.unshift(itemArray);

        const objSend = {
          idProposta: this.dadosProposta.idProposta,
          idRegional: this.dadosProposta.idRegional,
          produtos: produtosAtulizar,
        };

        await this.atulizaProdutosOpcionais('alteraOpcional', objSend);

        if (item.id_tipoProduto === TIPO_PRODUTO.TIPO_PRODUTO_CASCO) {
          const participacao = await obterParticipacaoProdutoInvoice(
            item,
            selecionado,
          );

          const { valorCotaParticipacao, valorParticipacaoMinimo } =
            participacao;

          await service.post('CotacaoAberta', 'atualizarParticipacao', {
            idEmpresa: this.dadosProposta.idEmpresa,
            idProposta: this.dadosProposta.idProposta,
            produto: item,
            valorCotaParticipacao,
            valorParticipacaoMinimo,
            idProspect: this.dadosProposta.dadosCliente.idProspect,
          });
        }
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Não foi possível Atualizar opcionais do veículo',
        );
        this.isRecalculating = false;
      }
    },
    formataDados() {
      this.dadosProposta.produtos.forEach((element) => {
        if (element.obrigatorio) {
          this.produtosObrigatorios.push(element);
          return;
        }
        this.produtosOpcionais.push(element);
      });
    },
    verificaRastreio() {
      this.produtosObrigatorios.forEach((element) => {
        if (element.id_tipoProduto == 4) {
          return 'Obrigatório';
        }
      });
      var jsonFacilitador = this.dadosProposta.jsonFacilitador
        ? JSON.parse(this.dadosProposta.jsonFacilitador)
        : '';
      if (jsonFacilitador) {
        jsonFacilitador.forEach((element) => {
          if (element.id_tipoProduto == 4) {
            return 'Obrigatório';
          }
        });
      }
      return 'Opcional';
    },
    copiarText() {
      let linkRelativo = window.location.origin;
      // var msg = "Linha digitável copiado para a área de Transfêrencia";
      //O texto que será copiado
      const texto = `${linkRelativo}/proposta/${this.dadosProposta.chave}`;
      //Cria um elemento input (pode ser um textarea)
      let inputTest = document.createElement('input');
      inputTest.value = texto;
      //Anexa o elemento ao body
      document.body.appendChild(inputTest);
      //seleciona todo o texto do elemento
      inputTest.select();
      //executa o comando copy
      //aqui é feito o ato de copiar para a area de trabalho com base na seleção
      document.execCommand('copy');
      //remove o elemento
      document.body.removeChild(inputTest);
    },
    async applyDesconto() {
      try {
        this.dangerCupomDesconto = false;

        if (!this.cupomDesconto) {
          this.dangerCupomDesconto = true;
          notify.notifyFail(this.$vs, 'Informe o cupom!');
          return;
        }

        if (this.dadosProposta.cupom == this.cupomDesconto.toUpperCase()) {
          this.dangerCupomDesconto = true;
          notify.notifyFail(this.$vs, 'Este cupom já foi uitlizado!');
          return;
        }

        this.$vs.loading();

        const payload = {
          cupom: this.cupomDesconto.toUpperCase(),
          idProposta: this.dadosProposta.idProposta,
          idEmpresa: this.dadosProposta.idEmpresa,
          idRegional: this.dadosProposta.idRegional,
        };

        await service.post('Campanha', 'aplicarCupom', payload);
        this.cupomDesconto = '';

        this.buscaDados();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    mascaraCupom(event) {
      const input = event.target;
      input.value = input.value.replace(new RegExp(' ', 'g'), '-');
      this.dangerCupomDesconto = false;
    },
    popToast() {
      // Use a shorter name for this.$createElement
      const h = this.$createElement;
      var arrMsg = this.$validator.errors.all();
      var arrAux = [];
      arrMsg.forEach((element) => {
        arrAux.push(h('p', {}, element));
      });
      // Create the message
      const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, arrAux);

      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: 'Atenção!',
        solid: true,
        variant: 'danger',
        toaster: 'b-toaster-top-full',
        appendToast: true,
        autoHideDelay: 2500,
      });
    },
    returnLinkWhatsCliente(nome, celular) {
      let linkRelativo = window.location.origin;
      var texto = `Olá ${nome}, tudo bem? A proposta da ${this.dadosProposta.dadosAssociacao.nome} para proteger seu veículo foi gerada, você consegue aceita-la e fazer sua vistoria tudo por lá, acesse ${linkRelativo}/proposta/${this.dadosProposta.chave}`;

      var textoEncode = encodeURI(texto);

      var link = '';
      //if (isBrowser == true)
      link = `https://api.whatsapp.com/send?phone=55${celular}&text=${textoEncode}`;
      //else link = `whatsapp://send?phone=55${celular}&text=${textoEncode}`;

      return link;
    },
    returnLinkWhatsVendedor() {
      let linkRelativo = window.location.origin;
      var texto = `Olá ${this.dadosProposta.dadosVendedor.usuario}, tudo bem?Sua proposta para proteger seu veículo ${this.dadosProposta.dadosVeiculo.veiculoMarca} foi gerada, você consegue aceitá-la e fazer sua vistoria agora mesmo, acesse ${linkRelativo}/proposta/${this.dadosProposta.chave}`;
      var textoEncode = encodeURI(texto);

      var link = '';
      //if (isBrowser == true)
      link = `https://api.whatsapp.com/send?phone=55${this.dadosProposta.dadosVendedor.telefone}&text=${textoEncode}`;
      //else link = `whatsapp://send?phone=55${celular}&text=${textoEncode}`;

      return link;
    },
    async preencheForm() {
      this.formConfirmacao.nome = this.dadosProposta.dadosCliente.associado;
      this.formConfirmacao.email = this.dadosProposta.dadosCliente.email;
      this.formConfirmacao.cpfcnpj = this.dadosProposta.dadosCliente.cpf;
      this.formConfirmacao.celular = this.dadosProposta.dadosCliente.celular;
      this.formConfirmacao.rgIe = this.dadosProposta.dadosCliente.rg_ie;
      this.formConfirmacao.dataNascimento =
        this.dadosProposta.dadosCliente.dataNascimento;
      this.formConfirmacao.representanteLegal =
        this.dadosProposta.dadosCliente.representanteLegal;
      this.formConfirmacao.cpfRepresentante =
        this.dadosProposta.dadosCliente.cpfRepresentante;

      this.formConfirmacao.diaVencimentoMensalidade =
        this.dadosProposta.diaVencimentoMensalidade;

      if (this.dadosProposta.dadosCliente.tipo == 'Pessoa Física')
        this.tipoDePessoa = 1;
      else this.tipoDePessoa = 2;

      if (
        this.dadosProposta.dadosCliente.tipo == null ||
        this.dadosProposta.dadosCliente.tipo == undefined
      )
        this.tipoDePessoa = 1;

      this.formConfirmacao.cep = this.dadosProposta.dadosCliente.cep;
      this.formConfirmacao.endereco = this.dadosProposta.dadosCliente.endereco;
      this.formConfirmacao.numero = this.dadosProposta.dadosCliente.numero;
      this.formConfirmacao.complemento =
        this.dadosProposta.dadosCliente.complemento;
      this.formConfirmacao.bairro = this.dadosProposta.dadosCliente.bairro;
      this.formConfirmacao.estado = this.dadosProposta.dadosCliente.estado;
      this.formConfirmacao.cidade = this.dadosProposta.dadosCliente.cidade;

      await this.getListCidade(null, this.dadosProposta.dadosCliente.estado);
    },
    async buscaFormasPagamento() {
      this.$vs.loading();

      try {
        const { idProposta, idEmpresa } = this.dadosProposta;

        const formasPagamento = await service.post(
          'CotacaoAberta',
          'buscarFormasPagamento',
          {
            idEmpresa,
            idProposta,
          },
        );
        this.exibeFinanceiro = true;
        this.formasPagamentoEncontradas = true;
        this.formaPagamentoProdutos = formasPagamento.data;

        await this.selecionaFormaPagamento();

        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível encontrar as formas de Pagamento',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async selecionaFormaPagamento() {
      const { produtos } = this.dadosProposta;
      const { entrada, mensal, dinheiro } = this.formaPagamentoProdutos;

      const findFormaPagamento = (idFormaPagamento, tipo) => {
        return this.formaPagamentoProdutos[tipo].opcoes.find(
          (forma) => forma.value.idTipoPagamentoEmpresa === idFormaPagamento,
        );
      };

      for (const produto of produtos) {
        if (entrada.produtos.includes(produto.id_produto)) {
          const formaPagamento = findFormaPagamento(
            produto.idTipoPagamentoEmpresa,
            'entrada',
          );

          if (entrada.cobrancaApartada) {
            continue;
          }

          if (formaPagamento) {
            this.formConfirmacao.idFormaPagamentoAVista = formaPagamento.value;
            this.aoSelecionarFormaPagamento('entrada', formaPagamento.value);
          }
        }

        if (mensal.produtos.includes(produto.id_produto)) {
          const formaPagamento = findFormaPagamento(
            produto.idTipoPagamentoEmpresa,
            'mensal',
          );

          if (formaPagamento) {
            this.formConfirmacao.idFormaPagamentoMensal = formaPagamento.value;
            this.aoSelecionarFormaPagamento('mensal', formaPagamento.value);
          }
        }

        if (dinheiro.produtos.includes(produto.id_produto)) {
          const formaPagamento = findFormaPagamento(
            produto.idTipoPagamentoEmpresa,
            'dinheiro',
          );
          if (formaPagamento) {
            this.formConfirmacao.idFormaPagamentoDinheiro =
              formaPagamento.value;
          }
        }
      }
    },
    keymonitor: function () {
      if (this.formConfirmacao.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.formConfirmacao.cep
          .replace('.', '')
          .replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then(async (res) => {
            res.data = decryptData(res.data);
            this.formConfirmacao.endereco = res.data.street;
            this.formConfirmacao.bairro = res.data.neighborhood;
            this.formConfirmacao.cidade = res.data.city;
            this.formConfirmacao.estado = res.data.state;

            await this.getListCidade(null, res.data.state);

            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    buscaDados() {
      if (this.$route.query.interno) {
        this.isInterno = true;
      } else {
        this.isInterno = false;
      }
      this.$vs.loading();
      var objSend = {};
      objSend.chave = this.$route.params.chave;

      service
        .post('CotacaoAberta', 'buscaDados', objSend)
        .then(async (res) => {
          this.dadosProposta = res.data[0];
          document.title = `${
            this.dadosProposta.idEmpresa === this.empresa.ERP_GERAL
              ? 'Bem Protege'
              : this.dadosProposta.dadosAssociacao.nome
          } - Proposta - ${this.dadosProposta.idProposta}`;
          await this.translate(this.dadosProposta.idEmpresa);
          this.produtosOpcionais = [];
          if (
            this.dadosProposta.jsonFacilitadorProdutos &&
            this.dadosProposta.jsonFacilitadorProdutos != '0'
          ) {
            this.dadosProposta.jsonFacilitadorProdutos = JSON.parse(
              this.dadosProposta.jsonFacilitadorProdutos,
            );

            if (this.dadosProposta.jsonFacilitadorProdutos) {
              this.dadosProposta.jsonFacilitadorProdutos.forEach((element) => {
                // produtos não obrigatorios
                if (element.obrigatorio != true) {
                  element.selecionado = false;
                  const aux = this.dadosProposta.produtos.find(
                    (x) => x.id_produto == element.id_produto,
                  );

                  if (aux) {
                    element.selecionado = true;
                  }

                  const novoProduto = {
                    idProduto: element.id_produto,
                    selecionado: element.selecionado,
                    nomeProduto: element.nomeProduto,
                    valor: element.valor,
                    valorFinal: element.valorFinal,
                    isMensal: element.ismensal,
                    produtosLinkados: element.produtosLinkados,
                    sobreporOutrosProdutos: element.sobreporOutrosProdutos,
                    produtoVisivel: element.produtoVisivel,
                    visivelProposta: element.visivelProposta,
                    produtosComplementares: element.produtosComplementares,
                    isComplementar: element.isComplementar,
                    exibir: true,
                    valorCotaParticipacao: element.valorCotaParticipacao,
                    valorParticipacaoMinimo: element.valorParticipacaoMinimo,
                    id_tipoProduto: element.id_tipoProduto,
                  };

                  this.produtosOpcionais.push(novoProduto);
                }
              });
            }
          } else {
            this.dadosProposta.produtos.forEach((element) => {
              if (element.obrigatorio != true) {
                const novoProduto = {
                  idProduto: element.id_produto,
                  selecionado: true,
                  nomeProduto: element.nomeProduto,
                  descontoConcedido: element.descontoConcedido,
                  valorFinal: element.valorFinal,
                  isMensal: element.isMensal,
                  produtoVisivel: element.produtoVisivel,
                  visivelProposta: element.visivelProposta,
                  produtosComplementares: element.produtosComplementares,
                  isComplementar: element.isComplementar,
                  exibir: true,
                  valorCotaParticipacao: element.valorCotaParticipacao,
                  valorParticipacaoMinimo: element.valorParticipacaoMinimo,
                  idTipoProduto: element.idTipoProduto,
                };
                this.produtosOpcionais.push(novoProduto);
              }
            });
          }

          this.produtosOpcionais.forEach((prod) => {
            this.defineExibicaoProdutoOpcional(prod);
          });

          // opcionais ordem alfabética
          this.produtosOpcionais.sort((a, b) =>
            a.nomeProduto < b.nomeProduto
              ? -1
              : Number(a.nomeProduto > b.nomeProduto),
          );

          // produtos obrigatórios
          this.produtosObrigatorios = [];
          this.dadosProposta.produtos.forEach((element) => {
            if (element.obrigatorio) {
              this.produtosObrigatorios.push({
                idProduto: element.id_produto,
                selecionado: true,
                nomeProduto: element.nomeProduto,
                descontoConcedido: element.descontoConcedido,
                valor: element.valor,
                valorFinal: element.valorFinal,
                isMensal: element.isMensal,
                produtoVisivel: element.produtoVisivel,
                visivelProposta: element.visivelProposta,
                produtosComplementares: element.produtosComplementares,
                isComplementar: element.isComplementar,
                idTipoProduto: element.idTipoProduto,
                exibir: true,
              });
            }
          });

          const nomeCompleto =
            this.dadosProposta.dadosVendedor.usuario.split(' ');
          const p1 = nomeCompleto[0].substring(0, 1);
          const p2 = nomeCompleto[nomeCompleto.length - 1].substring(0, 1);
          this.nomeAvatar = p1 + p2;

          await this.preencheForm();

          this.buscaFormasPagamento(this.dadosProposta.idCarteiraCobranca);

          this.filtraProdutosOpcionais();
          this.filtraProdutosObrigatorios();
          this.marcaProdutosCarregamento();
          this.somaValorTotalMes(this.dadosProposta);

          const temAgregadosUnificados =
            this.dadosProposta.agregados &&
            this.dadosProposta.agregados.length > 0 &&
            this.dadosProposta.agregados[0].unificarAgregado;

          if (temAgregadosUnificados) {
            this.idsAgregadosUnificados = this.dadosProposta.agregados.map(
              (agregado) => agregado.idPropostaComplemento,
            );
          }

          const temAgregado =
            this.dadosProposta.agregado && this.dadosProposta.agregados;
          if (temAgregado) {
            const _agregados = this.dadosProposta.agregados.map(
              (item, index) => {
                const _jsonFacilitadorProdutos = JSON.parse(
                  item.JsonFacilitadorProdutos,
                );

                let produtosObrigatorios = [];
                let produtosNaoObrigatorios = [];
                let produtosOpcionais = [];

                if (!temAgregadosUnificados || index === 0) {
                  const {
                    produtosObrigatorios: _produtosObrigatorios,
                    produtosNaoObrigatorios: _produtosNaoObrigatorios,
                  } = this.formataProdutos(_jsonFacilitadorProdutos);

                  const dadosProdutosSelecionados = item.produtosAgregado;

                  produtosObrigatorios = _produtosObrigatorios.reduce(
                    (acc, prodOgrig) => {
                      const _prodObriSelecionado =
                        dadosProdutosSelecionados.find(
                          (produto) =>
                            produto.idProduto == prodOgrig.id_produto,
                        );

                      if (_prodObriSelecionado) {
                        const _produto = {
                          idPropostaProdutoComplemento:
                            _prodObriSelecionado.idPropostaProdutoComplemento,
                          idPropostaComplemento:
                            _prodObriSelecionado.idPropostaComplemento,
                          idProposta: _prodObriSelecionado.idProposta,
                          idProduto:
                            _prodObriSelecionado.id_produto ||
                            _prodObriSelecionado.idProduto ||
                            _prodObriSelecionado.id,
                          valor: _prodObriSelecionado.valor,
                          descontoConcedido:
                            _prodObriSelecionado.descontoConcedido,
                          valorFinal: _prodObriSelecionado.valorFinal,
                          valorDescontoCupom:
                            _prodObriSelecionado.valorDescontoCupom,
                          selecionado: true,
                          nomeProduto: _prodObriSelecionado.nomeProduto,
                          isMensal: _prodObriSelecionado.isMensal,
                          produtoVisivel: _prodObriSelecionado.produtoVisivel,
                          visivelProposta: _prodObriSelecionado.visivelProposta,
                          idTipoPagamentoEmpresa:
                            _prodObriSelecionado.idTipoPagamentoEmpresa,
                          idTipoDesconto: _prodObriSelecionado.idTipoDesconto,
                        };

                        acc.push(_produto);
                      }

                      return acc;
                    },
                    [],
                  );

                  produtosNaoObrigatorios = _produtosNaoObrigatorios.reduce(
                    (acc, prodNOgrig) => {
                      const _prodNaoObriSelecionado =
                        dadosProdutosSelecionados.find(
                          (produto) =>
                            produto.idProduto == prodNOgrig.id_produto,
                        );

                      if (_prodNaoObriSelecionado) {
                        const _produto = {
                          idPropostaProdutoComplemento:
                            _prodNaoObriSelecionado.idPropostaProdutoComplemento,
                          idPropostaComplemento:
                            _prodNaoObriSelecionado.idPropostaComplemento,
                          idProposta: _prodNaoObriSelecionado.idProposta,
                          idProduto:
                            _prodNaoObriSelecionado.id_produto ||
                            _prodNaoObriSelecionado.idProduto ||
                            _prodNaoObriSelecionado.id,
                          valor: _prodNaoObriSelecionado.valor,
                          descontoConcedido:
                            _prodNaoObriSelecionado.descontoConcedido,
                          valorFinal: _prodNaoObriSelecionado.valorFinal,
                          valorDescontoCupom:
                            _prodNaoObriSelecionado.valorDescontoCupom,
                          selecionado: true,
                          nomeProduto: _prodNaoObriSelecionado.nomeProduto,
                          isMensal: _prodNaoObriSelecionado.isMensal,
                          produtoVisivel:
                            _prodNaoObriSelecionado.produtoVisivel,
                          visivelProposta:
                            _prodNaoObriSelecionado.visivelProposta,
                          idTipoPagamentoEmpresa:
                            _prodNaoObriSelecionado.idTipoPagamentoEmpresa,
                          idTipoDesconto:
                            _prodNaoObriSelecionado.idTipoDesconto,
                          produtosLinkados:
                            _prodNaoObriSelecionado.produtosLinkados,
                          sobreporOutrosProdutos:
                            _prodNaoObriSelecionado.sobreporOutrosProdutos,
                        };

                        produtosOpcionais.push(_produto);
                        acc.push(_produto);
                      } else {
                        produtosOpcionais.push(prodNOgrig);
                      }

                      return acc;
                    },
                    [],
                  );
                }

                const produtosSelecionados = JSON.parse(
                  item.produtosSelecionados,
                );

                return {
                  ...item,
                  produtosObrigatorios,
                  produtosNaoObrigatorios,
                  dadosProdutosSelecionados: item.produtosAgregado,
                  produtosSelecionados,
                  produtosOpcionais,
                  produtosRemovidos: [],
                };
              },
            );

            this.agregados = _agregados;
          }

          const temImplemento =
            this.dadosProposta.implemento && this.dadosProposta.implementos;
          if (temImplemento) {
            this.implementos = this.dadosProposta.implementos;
          }

          this.produtosOpcionais = this.produtosOpcionais.filter(
            (produto) => produto.id_tipoProduto !== 17,
          );

          this.verificaExisteEscolhidoOpcional('veiculo');
          if (this.agregados.length > 0) {
            this.verificaExisteEscolhidoOpcional('agregado');
          }
          this.buscaConfigEmpresa();
          this.verificarPropostaVisualizada();

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.loading.close();
          console.error(e);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        })
        .finally(() => {
          this.isRecalculating = false;
        });
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async buscaRetornoRegistroFinanceiro() {
      this.contadorBuscaRegistro = this.contadorBuscaRegistro + 1;

      await this.sleep(10000);

      if (!this.retornoRegistroFinanceiro) {
        this.$vs.loading();
        service
          .post('CotacaoAberta', 'buscaDadosProcessamentoRegistroFinanceiro', {
            idRegistroFinanceiro: this.idRegistroFinanceiro,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.data[0].dataProcessamento) {
              this.retornoRegistroFinanceiro = res.data[0];
              this.retornoAPI = JSON.parse(
                this.retornoRegistroFinanceiro.retornoAPI,
              );
            } else {
              this.buscaRetornoRegistroFinanceiro();
            }
          })
          .catch((e) => {
            console.error(e);
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      }
    },
    copiarLinhaDigitavel() {
      //O texto que será copiado
      const texto = this.retornoRegistroFinanceiro.linhaDigitavel;
      //Cria um elemento input (pode ser um textarea)
      let inputTest = document.createElement('input');
      inputTest.value = texto;
      //Anexa o elemento ao body
      document.body.appendChild(inputTest);
      //seleciona todo o texto do elemento
      inputTest.select();
      //executa o comando copy
      //aqui é feito o ato de copiar para a area de trabalho com base na seleção
      document.execCommand('copy');
      //remove o elemento
      document.body.removeChild(inputTest);
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'QR Code foi copiado para a área de Transfêrencia',
        color: 'success',
        time: 5000,
      });
    },
    copiarQR() {
      //O texto que será copiado
      const texto = this.retornoRegistroFinanceiro.pixQrCode;
      //Cria um elemento input (pode ser um textarea)
      let inputTest = document.createElement('input');
      inputTest.value = texto;
      //Anexa o elemento ao body
      document.body.appendChild(inputTest);
      //seleciona todo o texto do elemento
      inputTest.select();
      //executa o comando copy
      //aqui é feito o ato de copiar para a area de trabalho com base na seleção
      document.execCommand('copy');
      //remove o elemento
      document.body.removeChild(inputTest);
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'QR Code foi copiado para a área de Transfêrencia',
        color: 'success',
        time: 5000,
      });
    },
    trocarFormaPagamento() {
      this.retornoRegistroFinanceiro = null;
      this.idRegistroFinanceiro = null;
    },
    continuarParaVistoria() {
      if (this.linkRedirect) window.location = this.linkRedirect;
    },
    validaContinuarVistoria() {
      let retorno = true;

      if (
        this.retornoRegistroFinanceiro.formaPagamento == 'Cartão de Crédito'
      ) {
        if (this.retornoAPI.Charge.Transactions[0].status == 'denied')
          retorno = false;
      }

      return retorno;
    },
    formataProdutos(produtos) {
      const _produtos = produtos;

      const produtosObrigatorios = _produtos.filter(
        ({ obrigatorio }) => obrigatorio === true,
      );

      const produtosNaoObrigatorios = _produtos.filter(
        ({ obrigatorio }) => obrigatorio === false,
      );

      const dadosProdutosSelecionados = produtosObrigatorios;

      return {
        produtosObrigatorios,
        produtosNaoObrigatorios,
        dadosProdutosSelecionados,
      };
    },
    async selecionaProdutoAgregado(item, selecionado, idAgregado) {
      try {
        this.isRecalculating = true;
        const produtosAtulizar = [];
        const temAgregadosUnificados =
          this.agregados &&
          this.agregados.length > 0 &&
          this.agregados[0].unificarAgregados;
        const indexAgregado = temAgregadosUnificados ? 0 : idAgregado;

        if (item.sobreporOutrosProdutos) {
          const podeSobreporOutrosProdutos =
            item.sobreporOutrosProdutos.split(',');

          podeSobreporOutrosProdutos.forEach((idProduto) => {
            this.agregados[indexAgregado].produtosOpcionais.forEach(
              (elementSel) => {
                if (idProduto == elementSel.idProduto) {
                  if (item.selecionado && elementSel.selecionado) {
                    elementSel.selecionado = false;
                    const prodSobreposto = {
                      idProposta: this.dadosProposta.idProposta,

                      acao: elementSel.selecionado ? 'adicionar' : 'remover',

                      idProduto: elementSel.idProduto,

                      valorFinal: elementSel.valorFinal,
                    };

                    produtosAtulizar.push(prodSobreposto);
                  }
                }
              },
            );
          });
        }

        const idsProdutosLinkados = item.produtosLinkados.split(',');

        idsProdutosLinkados.forEach((idLink) => {
          if (idLink) {
            this.agregados[indexAgregado].produtosOpcionais.forEach(
              (element) => {
                if (idLink == element.idProduto) {
                  element.selecionado = selecionado;

                  const _produto = {
                    idProposta: this.dadosProposta.idProposta,
                    acao: element.selecionado ? 'adicionar' : 'remover',
                    idProduto: element.idProduto,
                    valorFinal: element.valorFinal,
                  };

                  produtosAtulizar.push(_produto);
                }
              },
            );
          }
        });

        if (item.sobreporOutrosProdutos) {
          var prodssobreporOutrosProdutos =
            item.sobreporOutrosProdutos.split(',');
          prodssobreporOutrosProdutos.forEach((idProduto) => {
            this.agregados[indexAgregado].produtosObrigatorios.forEach(
              (elementSel, index) => {
                if (elementSel.idProduto == idProduto) {
                  if (item.selecionado == true) {
                    this.agregados[indexAgregado].produtosRemovidos.push(
                      elementSel,
                    );
                    elementSel.excluido = true;
                  } else {
                    this.agregados[indexAgregado].produtosRemovidos.splice(
                      index,
                      1,
                    );
                    elementSel.excluido = false;
                  }
                }
              },
            );
          });
        }

        const acao = selecionado ? 'adicionar' : 'remover';

        const objSend = {};
        objSend.idProposta = this.agregados[indexAgregado].idProposta;
        objSend.idPropostaComplemento =
          this.agregados[indexAgregado].idPropostaComplemento;
        objSend.acao = acao;
        objSend.idProduto = item.idProduto || item.id_produto || item.id;
        objSend.idPropostaProdutoComplemento =
          acao == 'remover' ? item.idPropostaProdutoComplemento : null;
        objSend.valorFinal = item.valorFinal;

        produtosAtulizar.unshift(objSend);
        produtosAtulizar.unshift(this.dadosProposta.idProposta);
        produtosAtulizar.unshift(
          this.agregados[indexAgregado].idPropostaComplemento,
        );
        produtosAtulizar.unshift(acao);
        produtosAtulizar.unshift(this.dadosProposta.idRegional);
        produtosAtulizar.unshift(this.idsAgregadosUnificados);
        produtosAtulizar.unshift(
          this.agregados[indexAgregado].unificarAgregado,
        );

        await this.atulizaProdutosOpcionais(
          'alteraOpcionalAgregado',
          produtosAtulizar,
        );
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Não foi possível Atualizar opcionais do agregado',
        );
        this.isRecalculating = false;
      }
    },
    exibeTrocaFormaPagamento() {
      let retorno = true;

      if (
        this.retornoRegistroFinanceiro.formaPagamento == 'Cartão de Crédito'
      ) {
        if (this.retornoAPI.Charge.Transactions[0].status != 'denied')
          retorno = false;
      }

      return retorno;
    },
    async atulizaProdutosOpcionais(acao, objSend) {
      try {
        this.$vs.loading();

        await service.post('CotacaoAberta', acao, objSend);

        this.buscaDados();
      } catch (error) {
        this.$vs.loading.close();

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Não foi possível Atualizar opcionais`,
          color: 'danger',
        });
      }
    },
    verificaExisteEscolhidoOpcional(tipo) {
      if (tipo == 'veiculo') {
        const existeOpcional = this.produtosOpcionais.find(
          (produto) => produto.selecionado,
        );
        existeOpcional
          ? (this.existeProdutoOpcionalVeiculoSelecionado = true)
          : (this.existeProdutoOpcionalVeiculoSelecionado = false);
        return;
      }

      if (tipo == 'agregado') {
        const existeOpcionalAgregado = this.agregados.find((agregado) => {
          return agregado.produtosOpcionais.find((produto) => {
            return produto.selecionado;
          });
        });
        existeOpcionalAgregado
          ? (this.existeProdutoOpcionalAgregadoSelecionado = true)
          : (this.existeProdutoOpcionalAgregadoSelecionado = false);
        return;
      }

      return false;
    },
    ajustaDataHoraUtc(data) {
      return moment.utc(data).local().format('DD/MM/YYYY HH:mm');
    },
    optionsDiasVencimento(arrayDiasVencimento) {
      const dataVistoria = new Date();
      const diaDoMesVistoria = dataVistoria.getDate();
      const arrStr = arrayDiasVencimento
        .split(',')
        .map(Number) // aqui converto o array de strings em numbers
        .sort((a, b) => a - b); // ordeno do menor para o maior
      if (diaDoMesVistoria >= 1 && diaDoMesVistoria <= 31) {
        const maxDay = Math.min(diaDoMesVistoria, 31); // seta o maxDay baseado no dia atual garantindo que seja menor que 31

        const novoArrayVencimento = arrStr.filter(
          (element) => element <= maxDay + 4 && maxDay - element <= 5,
        );

        return novoArrayVencimento.sort((a, b) => a - b);
      }
    },
    async buscaConfigEmpresa() {
      try {
        this.$vs.loading();
        const dadosEmpresa = await service.getAll(
          'g',
          {},
          'empresas/list/idEmpresa/' + this.dadosProposta.idEmpresa,
        );
        dadosEmpresa.data = decryptData(dadosEmpresa.data);

        const {
          exibeValidadeNaProposta,
          diasVencimento,
          vencimentoMensalidadeTipo,
        } = dadosEmpresa.data[0];
        this.$vs.loading.close();

        if (exibeValidadeNaProposta) this.exibeValidadeNaProposta = true;

        if (diasVencimento) {
          this.diasVencimento = functions.verificaEmpresaBemProtege(
            this.dadosProposta.idEmpresa,
          )
            ? this.optionsDiasVencimento(diasVencimento)
            : diasVencimento.split(',');

          this.diasVencimentoTypeCalendar =
            vencimentoMensalidadeTipo === 'calendar';
        }
      } catch (error) {
        console.error(error);
        notify.notifyFail(this.$vs, error);
      }
    },
    ordenaArraysCpfsDuplicados(idProspectA, idPropectB) {
      return idPropectB.id_prospect - idProspectA.id_prospect;
    },
    verificarPropostaVisualizada() {
      !this.dadosProposta.propostaVisualizada && this.visualizarProposta();
      !this.dadosProposta.propostaVisualizada &&
        this.notificarConsultorPropostaVisualizada();
    },
    visualizarProposta() {
      return service.post('CotacaoAberta', 'atualiza-tabela-proposta', {
        idProposta: this.dadosProposta.idProposta,
        propostaVisualizada: true,
      });
    },
    notificarConsultorPropostaVisualizada() {
      return service.post(
        'CotacaoAberta',
        'notificar-consultor-proposta-visualizada',
        {
          idEmpresaAlternativo: this.dadosProposta.idEmpresa,
          idProposta: this.dadosProposta.idProposta,
          idUsuario: this.dadosProposta.idUsuario,
        },
      );
    },
    redirectVistoriaV2() {
      const companyId = this.dadosProposta.idEmpresa;
      const proposalKey = this.dadosProposta.chave;

      if (
        companyId === this.empresa.ERP_GERAL ||
        companyId === this.empresa.BP_TRUCK
      ) {
        window.location = `${URL_VISTORIA}/${proposalKey}`;
        return;
      }

      if (companyId === this.empresa.BPVCMENSAL) {
        window.location = `${URL_VISTORIA_BPVCMENSAL}/${proposalKey}`;
        return;
      }

      const isLocalhost = window.location.origin.includes('localhost');
      const baseUrl = isLocalhost
        ? URL_VISTORIA_BPVCMENSAL
        : window.location.origin.replace('adm', 'vistoria');

      window.location = `${baseUrl}/${proposalKey}`;
    },
    async getListCidade(id, sigla = null) {
      if (sigla) {
        id = this.listEstados.find((x) => x.label == sigla).id;
      }

      if (!id) {
        return;
      }

      try {
        this.listCidade = await getSelectsCidades(this.$vs, id);
      } catch (error) {
        console.error(error);
        notify.notifyFail(this.$vs, error);
      }
    },
    async clearCidade(value) {
      this.formConfirmacao.cidade = null;

      if (value) {
        await this.getListCidade(value.id);
      }
    },

    defineExibicaoProdutoOpcional(produto) {
      //Verifica se o produto é pai de produtos complementares e não está selecionado
      if (produto.produtosComplementares && !produto.selecionado) {
        const produtosComplementares =
          produto.produtosComplementares.split(',');

        this.produtosOpcionais.forEach((prod) => {
          produtosComplementares.forEach((id) => {
            //Encontra o produto filho (complementar) e tira a exibição
            if (id == prod.idProduto.toString() && prod.exibir == true) {
              prod.exibir = false;
              prod.selecionado = false;

              //Deleta da proposta os produtos filhos
              const index = this.dadosProposta.produtos.findIndex((prod) => {
                return prod.id_produto.toString() == id;
              });

              if (index > 0) {
                this.dadosProposta.produtos.splice(index, 1);
              }
            }
          });
        });
      }
    },
    isCpfCanChange() {
      let retorno = true;
      if (
        this.dadosProposta.dadosCliente.situacao ||
        this.dadosProposta.dadosCliente.idStatus
      ) {
        retorno = false;
      }

      return retorno;
    },
    clickEntendi() {
      this.confirmarDados = true;
    },

    /**
     * Handles the selection of a day for monthly billing.
     *
     * @param {number} dia - The selected day for monthly billing.
     * @returns {void}
     * @emits reatribuiDiaVencimento - Emitted after updating the selected day with the selected day as payload.
     */
    diaSelecionado(dia) {
      this.formConfirmacao.diaVencimentoMensalidade = dia;
    },

    aoSelecionarFormaPagamento(tipo, valorSelecionado) {
      const tipoSelecionado = valorSelecionado.tipoPagamento;

      if (!tipoSelecionado) {
        this.formConfirmacao[this.getCampoPorTipo(tipo)] = null;
        return;
      }

      const isCartaoCredito = tipoSelecionado === this.TIPO_CARTAO_CREDITO;
      this.formConfirmacao[this.getCampoPorTipo(tipo)] = valorSelecionado;

      if (!['entrada', 'mensal'].includes(tipo)) {
        return;
      }

      this.exibeDiaVencimentoMensalidade = !isCartaoCredito;

      if (isCartaoCredito) {
        const outros = ['entrada', 'mensal'].filter((k) => k !== tipo);

        outros.forEach((key) => {
          const campo = this.getCampoPorTipo(key);
          const opcoes = this.formaPagamentoProdutos[key].opcoes;

          const itemCartao = opcoes.find(
            (o) => o.value.tipoPagamento === this.TIPO_CARTAO_CREDITO,
          );

          if (itemCartao) {
            this.formConfirmacao[campo] = itemCartao.value;
          }
        });

        return;
      }

      const outroTipo = tipo === 'entrada' ? 'mensal' : 'entrada';
      const campoOutro = this.getCampoPorTipo(outroTipo);
      const outroValor = this.formConfirmacao[campoOutro];

      const outroEhCartao =
        outroValor && outroValor.tipoPagamento === this.TIPO_CARTAO_CREDITO;

      if (outroEhCartao) {
        this.formConfirmacao[campoOutro] = null;
      }
    },

    getCampoPorTipo(tipo) {
      const mapa = {
        entrada: 'idFormaPagamentoAVista',
        mensal: 'idFormaPagamentoMensal',
      };

      return mapa[tipo] || '';
    },
  },
  async created() {
    this.listEstados = await getSelectsEstados();
    await this.buscaDados();

    this.$validator.localize('ptBr', locale);
  },
  components: { VxTooltip, vSelect, DateRadio },
};
</script>

<style>
@import url('https://fonts.cdnfonts.com/css/gotham');

* {
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}

/* .wrapperPage {
  font-family: 'regular', 'Gotham', sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
} */
.wrapperPage {
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
}
#myVideo {
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  max-height: 100%;
  object-fit: cover;
}

.header-aprove {
  background-color: #2ecc71;
  font-weight: 600 !important;
  font-size: 20px;
}

.whatsAppDiv {
  background-color: #2ecc71;
  border-radius: 40px;
  align-items: center;
}

.status3e4 {
  background-color: #ee8370;
  border-radius: 40px;
  align-items: center;
}

.whatsAppDiv:hover {
  cursor: pointer;
  animation: fadeBackgroundIn 0.5s;
  animation-fill-mode: forwards;
}
.linkVistoriaDiv {
  background-color: #2e98fc;
  border-radius: 40px;
  align-items: center;
}
.linkVistoriaDiv:hover {
  cursor: pointer;
  animation: fadeLinkVistoriaBg 0.3s;
  animation-fill-mode: forwards;
}

@keyframes fadeBackgroundIn {
  from {
    background-color: #2ecc71;
  }
  to {
    background-color: #26b564;
  }
}
@keyframes fadeLinkVistoriaBg {
  from {
    background-color: #2e98fc;
  }
  to {
    background-color: #2a7ddd;
  }
}

.wrapper {
  position: relative;
  top: 0;
  width: 100%;
}

.video {
  position: absolute;
  height: 100%;
  left: 0px;
}

.wppConsultor {
  flex-direction: column;
  align-items: center;
}

.wppTexto {
  font-size: 0.8rem;
  font-weight: 700 !important;
}
.wppNumero {
  font-size: 1.4rem;
  font-weight: 700 !important;
}

.blueBar {
  background-color: rgb(16, 72, 129);
  color: white;
  position: relative;
  height: 30vh;
  overflow: hidden;
  z-index: -1;
}

@media (min-width: 800px) {
  .blueBar {
    height: 35vh;
  }
}

.bar-without-video {
  height: auto !important;
}

.contInfo {
  justify-content: space-between;
  margin-top: -20px;
}

.textBlueBar1 {
  font-size: 1.3rem;
}

.textBlueBar2 {
  font-size: 1.5rem;
  font-weight: 700;
}

@media (min-width: 800px) {
  .blueBar {
    font-size: 1.8rem;
  }
}

.blocoInfo {
  background-color: white;
  border: 1px #d8e2ef solid;
  border-radius: 6px;
}

.titleListItems {
  font-weight: 600;
  color: rgb(59, 59, 59);
}

.listItemsProtecoes {
  color: rgb(59, 59, 59);
  font-size: 0.9rem;
  font-weight: 600;
}

.listItemsOpcionais {
  font-weight: 600;
  color: rgb(59, 59, 59);
  font-size: 0.8rem;
}

.wppCotacao {
  background-color: #93aabe;
}

.blocoValor {
  background-color: white;
  border: 1px #d8e2ef solid;
  border-radius: 6px;
  position: sticky;
  top: 10px;
}

.blocoValorCont {
  flex-direction: column;
  align-items: center;
}

.valueCotacao {
  font-weight: 800;
}

.icons-cotacao {
  cursor: pointer;
}

.queroContratar {
  font-weight: 600;
}

.avisoMensalidade {
  font-size: 0.8rem;
  font-weight: 500;
}

.subtituloDetalhes {
  font-weight: 550;
}

.avisoLeilao {
  background-color: #d3dfea;
}

.listItems {
  font-size: 1rem;
  color: black;
  font-weight: 600;
}

footer {
  background-color: #373f47;
}

.cotacaoFooter {
  font-size: 0.9rem;
}

.showMobile {
  display: none;
}

.rodape .showMobile span,
.rodape .showDesk span {
  padding-top: 1px;
}

.showInPrintVersion {
  display: none;
}

.footerDivStyle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}

@media (max-width: 576px) {
  .blueBar {
    height: 49vh !important;
  }

  .bar-without-video {
    height: auto !important;
  }

  .produtosBeneficios .flex {
    flex: 1;
    margin-right: 10px;
  }

  .produtosBeneficios .descricao .listItemsProtecoes {
    color: #666 !important;
    font-weight: normal;
  }

  .showMobile {
    display: block;
  }

  .showDesk {
    display: none;
  }

  .footerDivStyle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column !important;
  }
}

@media print {
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  html {
    font-size: 70%;
  }

  .capaImpressao {
    width: 100%;
    page-break-inside: avoid !important;
    display: block !important;
  }

  .vs-tooltip {
    display: none;
  }

  .logoPlusWpp {
    display: flex;
    justify-content: right !important;
    padding: 0 !important;
  }

  .blueBar {
    background-color: rgb(16, 72, 129) !important;
    color: white;
    padding: 1rem !important;
    height: auto !important;
    position: static;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .contInfo {
    margin: 0 auto !important;
    display: block !important;
  }

  .blocoValor {
    position: static !important;
  }

  .blocoValorPai {
    width: 39% !important;
    margin-top: 1rem;
  }

  .blocoInfoPai {
    width: 59% !important;
    margin-top: 1rem;
    margin-left: 0.8rem;
  }

  .avisoLeilao {
    background-color: #d3dfea;
    padding: 1rem !important;
  }

  .video {
    display: none;
  }

  .blocoInfo {
    background-color: white;
    border: 1px #d8e2ef solid;
    border-radius: 6px;
  }

  .medium {
    font-size: 1.5rem !important;
    width: 1.5rem !important;
    height: 1.5rem !important;
  }

  .blocoValorCont {
    flex-direction: column;
    align-items: center;
  }

  .showMobile {
    display: none;
  }

  .showDesk {
    display: block;
  }

  h1 {
    font-size: 200% !important;
  }

  h2 {
    font-size: 180% !important;
  }

  h3 {
    font-size: 160% !important;
  }

  h4 {
    font-size: 145% !important;
  }

  h5 {
    font-size: 130% !important;
  }

  .pagebreak-before {
    break-before: always;
    page-break-before: always;
  }

  .pagebreak-after {
    break-after: always;
    page-break-after: always;
  }

  .pagebreak-inside-avoid {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .hideInPrintVersion {
    display: none !important;
  }

  .showInPrintVersion {
    display: block;
  }

  .justifica {
    justify-content: space-between;
  }

  .footerDivStyle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
</style>

<style type="text/css" media="print">
@media print {
  body {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
@page {
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}

.error-select .vs__dropdown-toggle {
  border-color: rgba(var(--vs-danger), 1) !important;
}
</style>

<style scoped>
.border-success {
  border: 1px solid #2ecc71;
}

.border-dark {
  border: 1px solid #ebebeb !important;
}

.item-lista {
  cursor: pointer;
}

.fixed-bottom {
  position: fixed;
  bottom: 0px;
  width: 100%;
  text-align: center;
  border-radius: 0px;
  padding: 10px 0;
  z-index: 999;
}

.label-select {
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.4);
}

.con-vs-chip {
  min-height: 0;
  float: none;
  display: inline-block;
}
</style>
